import { useState, useEffect } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { Check, X, Plus, Trash2, Users, Building, Receipt, Star, Edit, ShoppingBag, Ticket, BookOpen, Upload, Search, Settings as SettingsIcon, FileText, CreditCard, MessageSquare, ThumbsUp, MoveUp, MoveDown, TrendingUp, BarChart3, DollarSign, Tag, Mail, Send, Copy, Eye, EyeOff, ScrollText, Wand2, RefreshCw, Loader2, Sparkles, LayoutGrid, Wallet, Shield, AlertTriangle, Lightbulb, Clock, Globe, Map, Gift, Info, Bell } from "lucide-react";
import { SiteMollieConnectionCard } from "@/components/SiteMollieConnectionCard";
import FeaturesManagement from "@/components/admin/FeaturesManagement";
import RoadmapManagement from "@/components/admin/RoadmapManagement";
import { SiteAdminReferralsTab } from "@/components/admin/SiteAdminReferralsTab";
import { Checkbox } from "@/components/ui/checkbox";
import { Switch } from "@/components/ui/switch";
import { EditUserDialog } from "@/components/EditUserDialog";
import { EditSubscriptionDialog } from "@/components/EditSubscriptionDialog";
import { EditShopItemDialog } from "@/components/EditShopItemDialog";
import { EditPricingPlanDialog } from "@/components/EditPricingPlanDialog";
import { EditAddonDialog } from "@/components/EditAddonDialog";
import { EditPolicyDialog } from "@/components/EditPolicyDialog";
import { EditEmailTemplateDialog } from "@/components/EditEmailTemplateDialog";
import { PreviewEmailTemplateDialog } from "@/components/PreviewEmailTemplateDialog";
import { EmailSetupInstructions } from "@/components/EmailSetupInstructions";
import { EditSEODialog } from "@/components/EditSEODialog";
import { ImageUploader } from "@/components/ImageUploader";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from "recharts";

export default function SiteAdmin() {
  const [pendingIdeas, setPendingIdeas] = useState<any[]>([]);
  const [approvedIdeas, setApprovedIdeas] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [parents, setParents] = useState<any[]>([]);
  const [subscriptions, setSubscriptions] = useState<any[]>([]);
  const [allPTAs, setAllPTAs] = useState<any[]>([]);
  const [sponsorships, setSponsorships] = useState<any[]>([]);
  const [shopItems, setShopItems] = useState<any[]>([]);
  const [tickets, setTickets] = useState<any[]>([]);
  const [blogPosts, setBlogPosts] = useState<any[]>([]);
  const [changelog, setChangelog] = useState<any[]>([]);
  const [pricingPlans, setPricingPlans] = useState<any[]>([]);
  const [planFeatures, setPlanFeatures] = useState<Record<string, any[]>>({});
  const [addons, setAddons] = useState<any[]>([]);
  const [policies, setPolicies] = useState<any[]>([]);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editPlanDialogOpen, setEditPlanDialogOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const [selectedPlanFeatures, setSelectedPlanFeatures] = useState<any[]>([]);
  const [editAddonDialogOpen, setEditAddonDialogOpen] = useState(false);
  const [selectedAddon, setSelectedAddon] = useState<any>(null);
  const [editPolicyDialogOpen, setEditPolicyDialogOpen] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState<any>(null);
  const [blogDialogOpen, setBlogDialogOpen] = useState(false);
  const [editBlogDialogOpen, setEditBlogDialogOpen] = useState(false);
  const [selectedBlogPost, setSelectedBlogPost] = useState<any>(null);
  const [editBlogImageFile, setEditBlogImageFile] = useState<File | null>(null);
  const [shopDialogOpen, setShopDialogOpen] = useState(false);
  const [changelogDialogOpen, setChangelogDialogOpen] = useState(false);
  const [editUserDialogOpen, setEditUserDialogOpen] = useState(false);
  const [editSubDialogOpen, setEditSubDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [selectedSub, setSelectedSub] = useState<any>(null);
  const [selectedShopItem, setSelectedShopItem] = useState<any>(null);
  const [editShopDialogOpen, setEditShopDialogOpen] = useState(false);
  const [editIdeaDialogOpen, setEditIdeaDialogOpen] = useState(false);
  const [selectedIdea, setSelectedIdea] = useState<any>(null);
  const [editChangelogDialogOpen, setEditChangelogDialogOpen] = useState(false);
  const [selectedChangelog, setSelectedChangelog] = useState<any>(null);
  
  // User images are now editable directly via selectedIdea.images state
  const [registrationsDisabled, setRegistrationsDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchUsers, setSearchUsers] = useState("");
  const [searchParents, setSearchParents] = useState("");
  const [searchSubs, setSearchSubs] = useState("");
  const [searchPTAs, setSearchPTAs] = useState("");
  const [editPTADialogOpen, setEditPTADialogOpen] = useState(false);
  const [selectedPTA, setSelectedPTA] = useState<any>(null);
  const [ptaForm, setPtaForm] = useState({ name: "", school_name: "", county: "", charity_number: "", shared_email: "" });
  const [filterPlan, setFilterPlan] = useState("all");
  const [filterStatus, setFilterStatus] = useState("all");
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [blogImageFile, setBlogImageFile] = useState<File | null>(null);
  const [amazonAffiliateTag, setAmazonAffiliateTag] = useState("");
  const [showAffiliateSettings, setShowAffiliateSettings] = useState(false);
  
  // Auto Blog state
  const [showBlogIdeas, setShowBlogIdeas] = useState(false);
  const [blogIdeas, setBlogIdeas] = useState<{id: string; title: string}[]>([]);
  const [isLoadingIdeas, setIsLoadingIdeas] = useState(false);
  const [hasLoadedIdeas, setHasLoadedIdeas] = useState(false);
  const [isGeneratingPost, setIsGeneratingPost] = useState(false);
  const [isGeneratingCover, setIsGeneratingCover] = useState(false);
  const [generatingIdeaIndex, setGeneratingIdeaIndex] = useState<number | null>(null);
  const [blogFormData, setBlogFormData] = useState({
    title: "",
    author_name: "",
    tags: "",
    excerpt: "",
    content: ""
  });
  
  // Blog preview state
  const [previewBlogPost, setPreviewBlogPost] = useState<any>(null);
  const [previewBlogDialogOpen, setPreviewBlogDialogOpen] = useState(false);
  const [maintenanceEnabled, setMaintenanceEnabled] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState("");
  const [maintenanceId, setMaintenanceId] = useState<string | null>(null);
  
  // Forum state
  const [forumCategories, setForumCategories] = useState<any[]>([]);
  const [forumThreads, setForumThreads] = useState<any[]>([]);
  const [forumPosts, setForumPosts] = useState<any[]>([]);
  const [forumPostReports, setForumPostReports] = useState<any[]>([]);
  const [featureRequests, setFeatureRequests] = useState<any[]>([]);
  const [selectedThread, setSelectedThread] = useState<any>(null);
  const [selectedThreadPost, setSelectedThreadPost] = useState<any>(null);
  const [categoryDialogOpen, setCategoryDialogOpen] = useState(false);
  const [editCategoryDialogOpen, setEditCategoryDialogOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [editThreadDialogOpen, setEditThreadDialogOpen] = useState(false);
  const [editPostDialogOpen, setEditPostDialogOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState<any>(null);
  const [selectedFeatureRequest, setSelectedFeatureRequest] = useState<any>(null);
  const [featureRequestDetailsOpen, setFeatureRequestDetailsOpen] = useState(false);
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [shopCategoryFilter, setShopCategoryFilter] = useState("all");
  
  // Trial/Sponsorship management state
  const [extendTrialDialogOpen, setExtendTrialDialogOpen] = useState(false);
  const [convertDialogOpen, setConvertDialogOpen] = useState(false);
  const [selectedForManagement, setSelectedForManagement] = useState<any>(null);
  const [newTrialEndDate, setNewTrialEndDate] = useState("");
  const [convertToPlan, setConvertToPlan] = useState("basic");
  
  // Search states for subscription tabs
  const [searchPaid, setSearchPaid] = useState("");
  const [searchTrials, setSearchTrials] = useState("");
  const [searchSponsored, setSearchSponsored] = useState("");
  const [searchInactive, setSearchInactive] = useState("");
  
  // Promo codes state
  const [promoCodes, setPromoCodes] = useState<any[]>([]);
  const [promoCodeDialogOpen, setPromoCodeDialogOpen] = useState(false);
  const [editPromoCodeDialogOpen, setEditPromoCodeDialogOpen] = useState(false);
  const [selectedPromoCode, setSelectedPromoCode] = useState<any>(null);
  
  // SEO state
  const [seoMetadata, setSeoMetadata] = useState<any[]>([]);
  const [selectedSEO, setSelectedSEO] = useState<any>(null);
  const [editSEODialogOpen, setEditSEODialogOpen] = useState(false);
  
  // Email templates state
  const [emailTemplates, setEmailTemplates] = useState<any[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [editTemplateDialogOpen, setEditTemplateDialogOpen] = useState(false);
  const [previewTemplateDialogOpen, setPreviewTemplateDialogOpen] = useState(false);
  const [testEmailAddress, setTestEmailAddress] = useState("");
  const [sendingTestEmail, setSendingTestEmail] = useState(false);
  
  // Summary stats state
  const [summaryStats, setSummaryStats] = useState({
    totalUsers: 0,
    totalPTAs: 0,
    activeSubscriptions: 0,
    reportedPosts: 0,
    pendingLibrary: 0,
    openTickets: 0,
    totalShopItems: 0,
    activeSponsorships: 0
  });
  
  // Site admins state
  const [siteAdmins, setSiteAdmins] = useState<any[]>([]);
  const [siteAdminPermissions, setSiteAdminPermissions] = useState<any[]>([]);
  const [editAdminDialogOpen, setEditAdminDialogOpen] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState<any>(null);
  const [selectedAdminTabs, setSelectedAdminTabs] = useState<string[]>([]);
  
  // Parent management state
  const [selectedParent, setSelectedParent] = useState<any>(null);
  const [editParentDialogOpen, setEditParentDialogOpen] = useState(false);
  const [editParentForm, setEditParentForm] = useState({ full_name: "", email: "" });
  
  // Idea rejection state
  const [ideaRejectDialogOpen, setIdeaRejectDialogOpen] = useState(false);
  const [ideaToReject, setIdeaToReject] = useState<any>(null);
  const [ideaRejectionReason, setIdeaRejectionReason] = useState("");
  const [isRejectingIdea, setIsRejectingIdea] = useState(false);
  
  // Notices state
  const [notices, setNotices] = useState<any[]>([]);
  const [noticeDialogOpen, setNoticeDialogOpen] = useState(false);
  const [editingNotice, setEditingNotice] = useState<any>(null);
  const [noticeForm, setNoticeForm] = useState({
    title: "",
    message: "",
    bg_color: "#3b82f6",
    is_enabled: false,
    show_on_pta_admin: false,
    show_on_member_dashboard: false,
    starts_at: "",
    ends_at: "",
  });
  
  // Current user permissions state
  const [currentUserEmail, setCurrentUserEmail] = useState<string | null>(null);
  const [currentUserAllowedTabs, setCurrentUserAllowedTabs] = useState<string[]>([]);
  const [isPrimaryAdmin, setIsPrimaryAdmin] = useState(false);
  const [permissionsLoading, setPermissionsLoading] = useState(true);
  
  // Primary admin email - has full access to all tabs
  const PRIMARY_ADMIN_EMAIL = 'info@ptahub.co.uk';
  
  // All available tabs definition
  const ALL_TABS = [
    { value: 'summary', label: 'Summary', icon: BarChart3 },
    { value: 'library', label: 'Library', icon: Star },
    { value: 'users', label: 'Users', icon: Users },
    { value: 'subscriptions', label: 'PTA Subscriptions', icon: Receipt },
    { value: 'ptas', label: 'PTAs', icon: Building },
    { value: 'shop', label: 'Shop', icon: ShoppingBag },
    { value: 'tickets', label: 'Tickets', icon: Ticket },
    { value: 'blog', label: 'Blog', icon: BookOpen },
    { value: 'changelog', label: 'Changelog', icon: ScrollText },
    { value: 'pricing', label: 'Pricing', icon: CreditCard },
    { value: 'features', label: 'Features', icon: LayoutGrid },
    { value: 'forum', label: 'Forum', icon: MessageSquare },
    { value: 'emails', label: 'Email Templates', icon: Mail },
    { value: 'seo', label: 'SEO', icon: FileText },
    { value: 'payments', label: 'Payments', icon: Wallet },
    { value: 'settings', label: 'Settings', icon: SettingsIcon },
    { value: 'policies', label: 'Policies', icon: FileText },
    { value: 'roadmap', label: 'Roadmap', icon: Map },
    { value: 'referrals', label: 'Referrals', icon: Gift },
    { value: 'notices', label: 'Notices', icon: Bell },
    { value: 'admins', label: 'Admins', icon: Shield },
  ];
  
  // Recent activity state
  const [recentActivity, setRecentActivity] = useState<any[]>([]);
  
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    detailed_plan: "",
    season: ["All Year"] as string[],
    location: ["Indoor"] as string[],
    type: [] as string[],
    estimated_helpers: 5,
    estimated_income: "£0",
    estimated_pricing: "£0"
  });

  useEffect(() => {
    fetchCurrentUserPermissions();
    fetchSummaryStats();
    fetchIdeas();
    fetchUsers();
    fetchParents();
    fetchSubscriptions();
    fetchAllPTAs();
    fetchSponsorships();
    fetchShopItems();
    fetchTickets();
    fetchBlogPosts();
    fetchChangelog();
    fetchPricingPlans();
    fetchAddons();
    fetchPolicies();
    fetchNotices();
    fetchMaintenanceSettings();
    fetchForumCategories();
    fetchForumThreads();
    fetchForumPostReports();
    fetchFeatureRequests();
    fetchSEOMetadata();
    fetchEmailTemplates();
    fetchPromoCodes();
    fetchSiteAdmins();
    fetchRecentActivity();
  }, []);

  const fetchSummaryStats = async () => {
    try {
      const [membersCount, parentsCount, ptasCount, subsCount, reportedPostsCount, pendingLibraryCount, ticketsCount, shopCount, sponsorshipsCount] = await Promise.all([
        supabase.from('members').select('id', { count: 'exact', head: true }),
        supabase.from('parents').select('id', { count: 'exact', head: true }),
        supabase.from('ptas').select('id', { count: 'exact', head: true }),
        supabase.from('subscriptions').select('id', { count: 'exact', head: true }).eq('status', 'active'),
        supabase.from('forum_post_reports').select('id', { count: 'exact', head: true }).eq('status', 'pending'),
        supabase.from('fundraising_ideas').select('id', { count: 'exact', head: true }).eq('status', 'pending'),
        supabase.from('support_tickets').select('id', { count: 'exact', head: true }).eq('status', 'open'),
        supabase.from('shop_items').select('id', { count: 'exact', head: true }).is('pta_id', null),
        supabase.from('sponsorships').select('id', { count: 'exact', head: true }).eq('status', 'active')
      ]);

      setSummaryStats({
        totalUsers: (membersCount.count || 0) + (parentsCount.count || 0),
        totalPTAs: ptasCount.count || 0,
        activeSubscriptions: subsCount.count || 0,
        reportedPosts: reportedPostsCount.count || 0,
        pendingLibrary: pendingLibraryCount.count || 0,
        openTickets: ticketsCount.count || 0,
        totalShopItems: shopCount.count || 0,
        activeSponsorships: sponsorshipsCount.count || 0
      });
    } catch (error) {
      console.error('Error fetching summary stats:', error);
    }
  };
  
  const fetchSiteAdmins = async () => {
    try {
      // Fetch all users with site_admin role
      const { data: adminRoles, error: rolesError } = await supabase
        .from('user_roles')
        .select('user_id')
        .eq('role', 'site_admin');
      
      if (rolesError) {
        console.error('Error fetching site admin roles:', rolesError);
        return;
      }
      
      if (!adminRoles || adminRoles.length === 0) {
        setSiteAdmins([]);
        return;
      }
      
      // Get profile info for each admin
      const userIds = adminRoles.map(r => r.user_id);
      const { data: profiles, error: profilesError } = await supabase
        .from('profiles')
        .select('id, email, full_name, created_at')
        .in('id', userIds);
      
      if (profilesError) {
        console.error('Error fetching admin profiles:', profilesError);
        return;
      }
      
      // Get permissions for each admin
      const { data: permissions } = await supabase
        .from('site_admin_permissions')
        .select('*')
        .in('user_id', userIds);
      
      setSiteAdminPermissions(permissions || []);
      setSiteAdmins(profiles || []);
    } catch (error) {
      console.error('Error fetching site admins:', error);
    }
  };
  
  const fetchCurrentUserPermissions = async () => {
    try {
      setPermissionsLoading(true);
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      
      const userEmail = user.email || '';
      setCurrentUserEmail(userEmail);
      
      // Primary admin gets full access
      if (userEmail === PRIMARY_ADMIN_EMAIL) {
        setIsPrimaryAdmin(true);
        setCurrentUserAllowedTabs(ALL_TABS.map(t => t.value));
        return;
      }
      
      setIsPrimaryAdmin(false);
      
      // Fetch this user's permissions
      const { data: permissions, error } = await supabase
        .from('site_admin_permissions')
        .select('allowed_tabs')
        .eq('user_id', user.id)
        .single();
      
      if (error || !permissions) {
        // If no permissions record, default to no access
        console.error('Error fetching current user permissions:', error);
        setCurrentUserAllowedTabs([]);
        return;
      }
      
      setCurrentUserAllowedTabs(permissions.allowed_tabs || []);
    } catch (error) {
      console.error('Error fetching current user permissions:', error);
    } finally {
      setPermissionsLoading(false);
    }
  };
  
  const fetchRecentActivity = async () => {
    try {
      // Fetch recent PTA signups
      const { data: recentPTAs } = await supabase
        .from('ptas')
        .select('id, name, created_at')
        .order('created_at', { ascending: false })
        .limit(3);
      
      // Fetch recent subscription changes
      const { data: recentSubs } = await supabase
        .from('subscriptions')
        .select('id, plan, status, created_at, ptas!subscriptions_pta_id_fkey(name)')
        .order('created_at', { ascending: false })
        .limit(3);
      
      // Fetch recent library submissions
      const { data: recentLibrary } = await supabase
        .from('fundraising_ideas')
        .select('id, title, status, created_at')
        .order('created_at', { ascending: false })
        .limit(3);
      
      // Combine and sort activities
      const activities: any[] = [];
      
      (recentPTAs || []).forEach(pta => {
        activities.push({
          type: 'pta_signup',
          title: `New PTA: ${pta.name}`,
          timestamp: pta.created_at,
          icon: 'Building'
        });
      });
      
      (recentSubs || []).forEach(sub => {
        activities.push({
          type: 'subscription',
          title: `${sub.ptas?.name || 'Unknown PTA'} - ${sub.status} (${sub.plan})`,
          timestamp: sub.created_at,
          icon: 'Receipt'
        });
      });
      
      (recentLibrary || []).forEach(idea => {
        activities.push({
          type: 'library',
          title: `Library submission: ${idea.title}`,
          timestamp: idea.created_at,
          icon: 'Lightbulb'
        });
      });
      
      // Sort by timestamp and take top 5
      activities.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
      setRecentActivity(activities.slice(0, 5));
    } catch (error) {
      console.error('Error fetching recent activity:', error);
    }
  };

  const fetchIdeas = async () => {
    const { data: pending } = await supabase
      .from('fundraising_ideas')
      .select('*')
      .eq('status', 'pending')
      .order('created_at', { ascending: false });

    const { data: approved } = await supabase
      .from('fundraising_ideas')
      .select('*')
      .eq('status', 'approved')
      .order('created_at', { ascending: false });

    setPendingIdeas(pending || []);
    setApprovedIdeas(approved || []);
  };

  const fetchUsers = async () => {
    const { data, error } = await supabase
      .from('members')
      .select(`
        id,
        user_id,
        full_name,
        email,
        role,
        is_pta_admin,
        created_at,
        pta_id,
        admin_notes,
        ptas (name, school_name)
      `)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching users:', error);
      toast({
        title: "Error",
        description: "Failed to fetch PTA members",
        variant: "destructive",
      });
      return;
    }

    // Fetch roles for each user
    const usersWithRoles = await Promise.all(
      (data || []).map(async (user) => {
        const { data: roles } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', user.user_id);
        
        return {
          ...user,
          user_roles: roles || []
        };
      })
    );

    setUsers(usersWithRoles);
  };

  const fetchParents = async () => {
    const { data, error } = await supabase
      .from('parents')
      .select(`
        id,
        user_id,
        full_name,
        email,
        created_at,
        pta_id,
        ptas (name, school_name)
      `)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching parents:', error);
      toast({
        title: "Error",
        description: "Failed to fetch parents",
        variant: "destructive",
      });
      return;
    }

    setParents(data || []);
  };

  const fetchSubscriptions = async () => {
    const { data, error } = await supabase
      .from('subscriptions')
      .select(`
        *,
        ptas!subscriptions_pta_id_fkey (id, name, school_name, charity_number, shared_email)
      `)
      .order('created_at', { ascending: false});

    if (error) {
      console.error('Error fetching subscriptions:', error);
      toast({
        title: "Error",
        description: "Failed to fetch subscriptions",
        variant: "destructive",
      });
      return;
    }

    setSubscriptions(data || []);
  };

  const fetchAllPTAs = async () => {
    const { data, error } = await supabase
      .from('ptas')
      .select('id, name, school_name, county, charity_number, shared_email, created_at, three_word_phrase')
      .order('name', { ascending: true });

    if (error) {
      console.error('Error fetching all PTAs:', error);
      return;
    }

    setAllPTAs(data || []);
  };

  const handleDeletePTA = async (ptaId: string, ptaName: string) => {
    if (!confirm(`Are you sure you want to delete "${ptaName}"? This action cannot be undone.`)) return;
    const { error } = await supabase.from('ptas').delete().eq('id', ptaId);
    if (error) {
      toast({ title: "Error", description: "Failed to delete PTA", variant: "destructive" });
    } else {
      toast({ title: "Success", description: "PTA deleted" });
      fetchAllPTAs();
    }
  };

  const handleSavePTA = async () => {
    if (!ptaForm.name.trim()) {
      toast({ title: "Error", description: "PTA name is required", variant: "destructive" });
      return;
    }
    if (selectedPTA) {
      const { error } = await supabase.from('ptas').update({
        name: ptaForm.name,
        school_name: ptaForm.school_name || null,
        county: ptaForm.county || null,
        charity_number: ptaForm.charity_number || null,
        shared_email: ptaForm.shared_email || null,
      }).eq('id', selectedPTA.id);
      if (error) {
        toast({ title: "Error", description: "Failed to update PTA", variant: "destructive" });
      } else {
        toast({ title: "Success", description: "PTA updated" });
        setEditPTADialogOpen(false);
        fetchAllPTAs();
      }
    } else {
      const { error } = await supabase.from('ptas').insert({
        name: ptaForm.name,
        school_name: ptaForm.school_name || null,
        county: ptaForm.county || null,
        charity_number: ptaForm.charity_number || null,
        shared_email: ptaForm.shared_email || null,
      });
      if (error) {
        toast({ title: "Error", description: "Failed to create PTA", variant: "destructive" });
      } else {
        toast({ title: "Success", description: "PTA created" });
        setEditPTADialogOpen(false);
        fetchAllPTAs();
      }
    }
  };

  const openEditPTA = (pta: any) => {
    setSelectedPTA(pta);
    setPtaForm({
      name: pta.name || "",
      school_name: pta.school_name || "",
      county: pta.county || "",
      charity_number: pta.charity_number || "",
      shared_email: pta.shared_email || "",
    });
    setEditPTADialogOpen(true);
  };

  const openAddPTA = () => {
    setSelectedPTA(null);
    setPtaForm({ name: "", school_name: "", county: "", charity_number: "", shared_email: "" });
    setEditPTADialogOpen(true);
  };

  const fetchSponsorships = async () => {
    const { data, error } = await supabase
      .from('sponsorships')
      .select(`
        *,
        ptas (id, name, school_name)
      `)
      .order('created_at', { ascending: false});

    if (error) {
      console.error('Error fetching sponsorships:', error);
      toast({
        title: "Error",
        description: "Failed to fetch sponsorships",
        variant: "destructive",
      });
      return;
    }

    setSponsorships(data || []);
  };

  const fetchShopItems = async () => {
    const { data } = await supabase
      .from('shop_items')
      .select('*')
      .is('pta_id', null)  // Only fetch global Amazon affiliate items, not PTA marketplace items
      .order('created_at', { ascending: false });

    setShopItems(data || []);
  };

  const fetchTickets = async () => {
    const { data } = await supabase
      .from('support_tickets')
      .select(`
        *
      `)
      .order('created_at', { ascending: false});

    setTickets(data || []);
  };

  const fetchBlogPosts = async () => {
    const { data } = await supabase
      .from('blog_posts')
      .select('*')
      .order('created_at', { ascending: false});

    setBlogPosts(data || []);
  };

  const fetchChangelog = async () => {
    const { data } = await supabase
      .from('changelog')
      .select('*')
      .order('created_at', { ascending: false});

    setChangelog((data as any) || []);
  };

  const fetchPricingPlans = async () => {
    const { data: plans } = await supabase
      .from('pricing_plans')
      .select('*')
      .order('display_order', { ascending: true });
    
    setPricingPlans(plans || []);

    // Fetch features for each plan
    if (plans) {
      const featuresMap: Record<string, any[]> = {};
      for (const plan of plans) {
        const { data: features } = await supabase
          .from('plan_features')
          .select('*')
          .eq('plan_id', plan.id)
          .order('feature_order', { ascending: true });
        
        featuresMap[plan.id] = features || [];
      }
      setPlanFeatures(featuresMap);
    }
  };

  const fetchAddons = async () => {
    const { data } = await supabase
      .from('pricing_addons')
      .select('*')
      .order('name', { ascending: true });
    
    setAddons(data || []);
  };

  const fetchNotices = async () => {
    const { data } = await supabase
      .from('site_notices')
      .select('*')
      .order('created_at', { ascending: false });
    setNotices(data || []);
  };

  const openNoticeDialog = (notice?: any) => {
    if (notice) {
      setEditingNotice(notice);
      setNoticeForm({
        title: notice.title || "",
        message: notice.message || "",
        bg_color: notice.bg_color || "#3b82f6",
        is_enabled: notice.is_enabled || false,
        show_on_pta_admin: notice.show_on_pta_admin || false,
        show_on_member_dashboard: notice.show_on_member_dashboard || false,
        starts_at: notice.starts_at ? new Date(notice.starts_at).toISOString().slice(0, 16) : "",
        ends_at: notice.ends_at ? new Date(notice.ends_at).toISOString().slice(0, 16) : "",
      });
    } else {
      setEditingNotice(null);
      setNoticeForm({ title: "", message: "", bg_color: "#3b82f6", is_enabled: false, show_on_pta_admin: false, show_on_member_dashboard: false, starts_at: "", ends_at: "" });
    }
    setNoticeDialogOpen(true);
  };

  const handleSaveNotice = async () => {
    if (!noticeForm.message.trim()) {
      toast({ title: "Error", description: "Message is required", variant: "destructive" });
      return;
    }
    const payload = {
      title: noticeForm.title.trim(),
      message: noticeForm.message.trim(),
      bg_color: noticeForm.bg_color,
      is_enabled: noticeForm.is_enabled,
      show_on_pta_admin: noticeForm.show_on_pta_admin,
      show_on_member_dashboard: noticeForm.show_on_member_dashboard,
      starts_at: noticeForm.starts_at ? new Date(noticeForm.starts_at).toISOString() : null,
      ends_at: noticeForm.ends_at ? new Date(noticeForm.ends_at).toISOString() : null,
    };
    let error;
    if (editingNotice) {
      ({ error } = await supabase.from('site_notices').update(payload).eq('id', editingNotice.id));
    } else {
      ({ error } = await supabase.from('site_notices').insert(payload));
    }
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: editingNotice ? "Notice updated" : "Notice created" });
      setNoticeDialogOpen(false);
      fetchNotices();
    }
  };

  const handleDeleteNotice = async (id: string) => {
    if (!confirm("Delete this notice?")) return;
    const { error } = await supabase.from('site_notices').delete().eq('id', id);
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Notice deleted" });
      fetchNotices();
    }
  };

  const fetchPolicies = async () => {
    const { data } = await supabase
      .from('site_policies')
      .select('*')
      .order('policy_type', { ascending: true });
    
    setPolicies(data || []);
  };

  const fetchSEOMetadata = async () => {
    const { data } = await supabase
      .from('seo_metadata')
      .select('*')
      .order('page_slug', { ascending: true });
    
    setSeoMetadata(data || []);
  };

  const fetchEmailTemplates = async () => {
    const { data } = await supabase
      .from('email_templates')
      .select('*')
      .order('template_type', { ascending: true });
    
    setEmailTemplates(data || []);
  };

  const fetchMaintenanceSettings = async () => {
    const { data } = await supabase
      .from('maintenance_settings')
      .select('*')
      .single();
    
    if (data) {
      setMaintenanceEnabled(data.enabled);
      setMaintenanceMessage(data.message);
      setMaintenanceId(data.id);
      setRegistrationsDisabled((data as any).registrations_disabled || false);
    }
  };

  const fetchForumCategories = async () => {
    const { data } = await supabase
      .from('forum_categories')
      .select('*')
      .order('display_order', { ascending: true });
    
    setForumCategories(data || []);
  };

  const fetchForumThreads = async () => {
    const { data } = await supabase
      .from('forum_threads')
      .select(`
        *,
        profiles (display_name, full_name),
        forum_categories (name)
      `)
      .order('created_at', { ascending: false });
    
    setForumThreads(data || []);
  };

  const fetchForumPostsForThread = async (threadId: string) => {
    const { data } = await supabase
      .from('forum_posts')
      .select(`
        *,
        profiles (display_name, full_name)
      `)
      .eq('thread_id', threadId)
      .order('created_at', { ascending: false });
    
    setForumPosts(data || []);
  };

  const fetchForumPostReports = async () => {
    const { data, error } = await supabase
      .from('forum_post_reports')
      .select(`
        *,
        forum_posts (id, content, thread_id, user_id, profiles:user_id (display_name, full_name, email)),
        reporter:profiles!reported_by (display_name, full_name, email)
      `)
      .order('created_at', { ascending: false });
    
    if (error) {
      console.error('Error fetching forum post reports:', error);
      return;
    }
    
    setForumPostReports(data || []);
  };

  const fetchFeatureRequests = async () => {
    const { data, error } = await supabase
      .from('forum_threads')
      .select(`
        *,
        profiles (display_name, full_name),
        forum_categories (name)
      `)
      .eq('is_feature_request', true)
      .order('vote_count', { ascending: false });
    
    if (error) {
      console.error('Error fetching feature requests:', error);
      toast({ title: "Error", description: error.message, variant: "destructive" });
      return;
    }
    
    console.log('Feature requests fetched:', data);
    setFeatureRequests(data || []);
  };

  const fetchPromoCodes = async () => {
    const { data, error } = await supabase
      .from('promo_codes')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) {
      console.error('Error fetching promo codes:', error);
      return;
    }
    
    setPromoCodes(data || []);
  };

  const handleAddPromoCode = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    const { error } = await supabase.from('promo_codes').insert([{
      code: (formData.get('code') as string).toUpperCase(),
      trial_days: parseInt(formData.get('trial_days') as string) || 28,
      max_uses: formData.get('max_uses') ? parseInt(formData.get('max_uses') as string) : null,
      expires_at: (formData.get('expires_at') as string) || null,
      description: (formData.get('description') as string) || null,
      is_active: true
    }]);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Promo code created!" });
      setPromoCodeDialogOpen(false);
      form.reset();
      fetchPromoCodes();
    }
  };

  const handleUpdatePromoCode = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedPromoCode) return;

    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    const { error } = await supabase.from('promo_codes')
      .update({
        code: (formData.get('code') as string).toUpperCase(),
        trial_days: parseInt(formData.get('trial_days') as string) || 28,
        max_uses: formData.get('max_uses') ? parseInt(formData.get('max_uses') as string) : null,
        expires_at: (formData.get('expires_at') as string) || null,
        description: (formData.get('description') as string) || null,
        is_active: formData.get('is_active') === 'on'
      })
      .eq('id', selectedPromoCode.id);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Promo code updated!" });
      setEditPromoCodeDialogOpen(false);
      setSelectedPromoCode(null);
      fetchPromoCodes();
    }
  };

  const handleDeletePromoCode = async (id: string) => {
    if (!confirm("Are you sure you want to delete this promo code?")) return;
    
    const { error } = await supabase.from('promo_codes').delete().eq('id', id);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Promo code deleted" });
      fetchPromoCodes();
    }
  };

  const handleTogglePromoCode = async (id: string, currentStatus: boolean) => {
    const { error } = await supabase.from('promo_codes')
      .update({ is_active: !currentStatus })
      .eq('id', id);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: `Promo code ${!currentStatus ? 'activated' : 'deactivated'}` });
      fetchPromoCodes();
    }
  };

  const handleAddCategory = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    const { error } = await supabase.from('forum_categories').insert({
      name: formData.get('name') as string,
      description: formData.get('description') as string,
      display_order: forumCategories.length
    });

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Category created!" });
      setCategoryDialogOpen(false);
      form.reset();
      fetchForumCategories();
    }
  };

  const handleUpdateCategory = async () => {
    if (!selectedCategory) return;

    const { error } = await supabase
      .from('forum_categories')
      .update({
        name: selectedCategory.name,
        description: selectedCategory.description
      })
      .eq('id', selectedCategory.id);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Category updated!" });
      setEditCategoryDialogOpen(false);
      setSelectedCategory(null);
      fetchForumCategories();
    }
  };

  const handleDeleteCategory = async (id: string) => {
    if (!confirm("Are you sure? This will also delete all threads and posts in this category.")) return;
    
    const { error } = await supabase.from('forum_categories').delete().eq('id', id);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Category deleted" });
      fetchForumCategories();
    }
  };

  const handleMoveCategoryUp = async (category: any, index: number) => {
    if (index === 0) return;
    
    const prevCategory = forumCategories[index - 1];
    
    await supabase.from('forum_categories').update({ display_order: index }).eq('id', prevCategory.id);
    await supabase.from('forum_categories').update({ display_order: index - 1 }).eq('id', category.id);
    
    fetchForumCategories();
  };

  const handleMoveCategoryDown = async (category: any, index: number) => {
    if (index === forumCategories.length - 1) return;
    
    const nextCategory = forumCategories[index + 1];
    
    await supabase.from('forum_categories').update({ display_order: index }).eq('id', nextCategory.id);
    await supabase.from('forum_categories').update({ display_order: index + 1 }).eq('id', category.id);
    
    fetchForumCategories();
  };

  const handleUpdateThread = async () => {
    if (!selectedThread) return;

    const { error } = await supabase
      .from('forum_threads')
      .update({
        title: selectedThread.title,
        is_pinned: selectedThread.is_pinned,
        is_locked: selectedThread.is_locked
      })
      .eq('id', selectedThread.id);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Thread updated!" });
      setEditThreadDialogOpen(false);
      setSelectedThread(null);
      fetchForumThreads();
      fetchFeatureRequests(); // Also refresh feature requests
    }
  };

  const handleDeleteThread = async (id: string) => {
    if (!confirm("Are you sure? This will also delete all posts in this thread.")) return;
    
    const { error } = await supabase.from('forum_threads').delete().eq('id', id);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Thread deleted" });
      fetchForumThreads();
      setSelectedThread(null);
      setForumPosts([]);
    }
  };

  const handleUpdatePost = async () => {
    if (!selectedPost) return;

    const { error } = await supabase
      .from('forum_posts')
      .update({
        title: selectedPost.title,
        content: selectedPost.content,
        is_hidden: selectedPost.is_hidden
      })
      .eq('id', selectedPost.id);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Post updated!" });
      setEditPostDialogOpen(false);
      setSelectedPost(null);
      if (selectedThread) {
        fetchForumPostsForThread(selectedThread.id);
      }
    }
  };

  const handleDeletePost = async (id: string) => {
    if (!confirm("Are you sure?")) return;
    
    const { error } = await supabase.from('forum_posts').delete().eq('id', id);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Post deleted" });
      if (selectedThread) {
        fetchForumPostsForThread(selectedThread.id);
      }
    }
  };

  const handleDismissReport = async (reportId: string) => {
    const { error } = await supabase
      .from('forum_post_reports')
      .update({ status: 'dismissed' })
      .eq('id', reportId);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Report dismissed" });
      fetchForumPostReports();
    }
  };

  const handleDeleteReport = async (reportId: string) => {
    const { error } = await supabase
      .from('forum_post_reports')
      .delete()
      .eq('id', reportId);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Report deleted" });
      fetchForumPostReports();
      fetchSummaryStats();
    }
  };

  const handleHideReportedPost = async (postId: string, reportId: string) => {
    const { error: postError } = await supabase
      .from('forum_posts')
      .update({ is_hidden: true })
      .eq('id', postId);
    
    if (postError) {
      toast({ title: "Error", description: postError.message, variant: "destructive" });
      return;
    }

    const { error: reportError } = await supabase
      .from('forum_post_reports')
      .update({ status: 'actioned' })
      .eq('id', reportId);
    
    if (!reportError) {
      toast({ title: "Success", description: "Post hidden and report actioned" });
      fetchForumPostReports();
    }
  };

  const handleUpdateFeatureRequestStatus = async (id: string, status: string, reason?: string) => {
    const updateData: any = { status };
    if (status === 'rejected' && reason) {
      updateData.rejection_reason = reason;
    }

    const { error } = await supabase
      .from('forum_threads')
      .update(updateData)
      .eq('id', id);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: `Feature request marked as ${status}` });
      fetchFeatureRequests();
      setRejectDialogOpen(false);
      setRejectionReason("");
      setSelectedFeatureRequest(null);
    }
  };

  const handleDeleteFeatureRequest = async (id: string) => {
    if (!confirm("Are you sure you want to delete this feature request?")) return;
    
    const { error } = await supabase
      .from('forum_threads')
      .delete()
      .eq('id', id);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Feature request deleted" });
      fetchFeatureRequests();
      setFeatureRequestDetailsOpen(false);
    }
  };

  const handleToggleShopItemStatus = async (id: string, currentStatus: string) => {
    const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
    const { error } = await supabase
      .from('shop_items')
      .update({ status: newStatus })
      .eq('id', id);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: `Shop item ${newStatus}` });
      fetchShopItems();
    }
  };

  const handleUpdateMaintenance = async () => {
    if (!maintenanceId) return;

    const { error } = await supabase
      .from('maintenance_settings')
      .update({
        enabled: maintenanceEnabled,
        message: maintenanceMessage,
        registrations_disabled: registrationsDisabled
      } as any)
      .eq('id', maintenanceId);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Settings updated successfully" });
    }
  };

  const handleAddBlogPost = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    let imageUrl = null;
    if (blogImageFile) {
      const fileExt = blogImageFile.name.split('.').pop();
      const filePath = `blog/${crypto.randomUUID()}.${fileExt}`;
      
      const { error: uploadError } = await supabase.storage
        .from('fundraising-images')
        .upload(filePath, blogImageFile);

      if (!uploadError) {
        const { data } = supabase.storage.from('fundraising-images').getPublicUrl(filePath);
        imageUrl = data.publicUrl;
      }
    }

    const tagsInput = formData.get('tags') as string;
    const tags = tagsInput ? tagsInput.split(',').map(t => t.trim()).filter(t => t) : [];

    const { error } = await supabase.from('blog_posts').insert({
      title: formData.get('title') as string,
      author_name: formData.get('author_name') as string || null,
      tags: tags,
      excerpt: formData.get('excerpt') as string,
      content: formData.get('content') as string,
      image_url: imageUrl,
      status: 'published',
      published_at: new Date().toISOString()
    });

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Blog post published!" });
      setBlogDialogOpen(false);
      setBlogImageFile(null);
      form.reset();
      fetchBlogPosts();
    }
  };

  // Auto Blog handlers
  const loadBlogIdeasFromDB = async () => {
    const { data, error } = await supabase
      .from('blog_ideas')
      .select('id, title, display_order')
      .order('display_order', { ascending: true });
    
    if (!error && data) {
      setBlogIdeas(data.map(d => ({ id: d.id, title: d.title })));
    }
    setHasLoadedIdeas(true);
  };

  const saveBlogIdeasToDB = async (ideas: {id?: string; title: string}[]) => {
    // Delete existing ideas and insert new ones
    await supabase.from('blog_ideas').delete().neq('id', '00000000-0000-0000-0000-000000000000');
    
    const toInsert = ideas.map((idea, index) => ({
      title: idea.title,
      display_order: index
    }));
    
    const { data, error } = await supabase.from('blog_ideas').insert(toInsert).select('id, title');
    
    if (!error && data) {
      return data.map(d => ({ id: d.id, title: d.title }));
    }
    return ideas.map(i => ({ id: i.id || '', title: i.title }));
  };

  const handleGetBlogIdeas = async () => {
    // First check if we have persisted ideas
    if (!hasLoadedIdeas) {
      await loadBlogIdeasFromDB();
    }
    
    // If we already have ideas in DB, just show them
    if (blogIdeas.length > 0) {
      setShowBlogIdeas(true);
      return;
    }
    
    // Otherwise generate new ones
    setIsLoadingIdeas(true);
    setShowBlogIdeas(true);
    
    try {
      const response = await supabase.functions.invoke('generate-blog-ideas', {
        body: { count: 10 }
      });
      
      if (response.error) {
        throw new Error(response.error.message);
      }
      
      if (response.data?.error) {
        throw new Error(response.data.error);
      }
      
      const newIdeas = (response.data?.ideas || []).map((title: string) => ({ id: '', title }));
      const savedIdeas = await saveBlogIdeasToDB(newIdeas);
      setBlogIdeas(savedIdeas);
    } catch (error) {
      console.error('Error fetching blog ideas:', error);
      toast({ 
        title: "Error", 
        description: error instanceof Error ? error.message : "Failed to generate blog ideas", 
        variant: "destructive" 
      });
    } finally {
      setIsLoadingIdeas(false);
    }
  };

  const handleRefreshAllIdeas = async () => {
    setIsLoadingIdeas(true);
    
    try {
      const response = await supabase.functions.invoke('generate-blog-ideas', {
        body: { count: 10 }
      });
      
      if (response.error) {
        throw new Error(response.error.message);
      }
      
      if (response.data?.error) {
        throw new Error(response.data.error);
      }
      
      const newIdeas = (response.data?.ideas || []).map((title: string) => ({ id: '', title }));
      const savedIdeas = await saveBlogIdeasToDB(newIdeas);
      setBlogIdeas(savedIdeas);
    } catch (error) {
      console.error('Error refreshing blog ideas:', error);
      toast({ 
        title: "Error", 
        description: error instanceof Error ? error.message : "Failed to refresh blog ideas", 
        variant: "destructive" 
      });
    } finally {
      setIsLoadingIdeas(false);
    }
  };

  const handleSelectIdea = async (index: number) => {
    const selectedIdea = blogIdeas[index];
    if (!selectedIdea) return;
    
    setGeneratingIdeaIndex(index);
    setIsGeneratingPost(true);
    
    try {
      // Generate the full blog post
      const response = await supabase.functions.invoke('generate-blog-post', {
        body: { title: selectedIdea.title }
      });
      
      if (response.error) {
        throw new Error(response.error.message);
      }
      
      if (response.data?.error) {
        throw new Error(response.data.error);
      }
      
      // Fill in the form data
      setBlogFormData({
        title: response.data.title || selectedIdea.title,
        author_name: response.data.author_name || 'PTA Hub Team',
        tags: response.data.tags || '',
        excerpt: response.data.excerpt || '',
        content: response.data.content || ''
      });
      
      // Generate cover image in the background
      setIsGeneratingCover(true);
      generateBlogCover(response.data.title || selectedIdea.title, response.data.excerpt || '');
      
      // Replace the used idea with a fresh one and save to DB
      const replaceResponse = await supabase.functions.invoke('generate-blog-ideas', {
        body: { count: 1 }
      });
      
      if (replaceResponse.data?.ideas?.length > 0) {
        const newIdeas = [...blogIdeas];
        // Delete the old idea from DB
        if (selectedIdea.id) {
          await supabase.from('blog_ideas').delete().eq('id', selectedIdea.id);
        }
        // Insert the new idea
        const { data: newIdeaData } = await supabase.from('blog_ideas').insert({
          title: replaceResponse.data.ideas[0],
          display_order: index
        }).select('id, title').single();
        
        if (newIdeaData) {
          newIdeas[index] = { id: newIdeaData.id, title: newIdeaData.title };
          setBlogIdeas(newIdeas);
        }
      }
      
      toast({ title: "Success", description: "Blog post generated! Cover image is being created..." });
      
    } catch (error) {
      console.error('Error generating blog post:', error);
      toast({ 
        title: "Error", 
        description: error instanceof Error ? error.message : "Failed to generate blog post", 
        variant: "destructive" 
      });
    } finally {
      setGeneratingIdeaIndex(null);
      setIsGeneratingPost(false);
    }
  };

  const generateBlogCover = async (title: string, excerpt: string) => {
    try {
      const response = await supabase.functions.invoke('generate-blog-cover', {
        body: { title, excerpt }
      });
      
      if (response.error) {
        throw new Error(response.error.message);
      }
      
      if (response.data?.error) {
        throw new Error(response.data.error);
      }
      
      if (response.data?.image_url) {
        // Convert base64 to File if needed, or set URL directly
        const imageUrl = response.data.image_url;
        
        if (imageUrl.startsWith('data:')) {
          // Convert base64 to file
          const res = await fetch(imageUrl);
          const blob = await res.blob();
          const file = new File([blob], 'cover.png', { type: 'image/png' });
          setBlogImageFile(file);
        } else {
          // For public URL, we need to download and create a file
          const res = await fetch(imageUrl);
          const blob = await res.blob();
          const file = new File([blob], 'cover.png', { type: 'image/png' });
          setBlogImageFile(file);
        }
        
        toast({ title: "Cover Generated", description: "AI cover image has been added to your blog post!" });
      }
    } catch (error) {
      console.error('Error generating cover:', error);
      toast({ 
        title: "Cover generation failed", 
        description: "You can still add a cover image manually.", 
        variant: "default" 
      });
    } finally {
      setIsGeneratingCover(false);
    }
  };

  const handleRefreshIdea = async (index: number) => {
    try {
      const oldIdea = blogIdeas[index];
      
      const response = await supabase.functions.invoke('generate-blog-ideas', {
        body: { count: 1 }
      });
      
      if (response.data?.ideas?.length > 0) {
        // Delete old idea from DB if it exists
        if (oldIdea?.id) {
          await supabase.from('blog_ideas').delete().eq('id', oldIdea.id);
        }
        
        // Insert new idea
        const { data: newIdeaData } = await supabase.from('blog_ideas').insert({
          title: response.data.ideas[0],
          display_order: index
        }).select('id, title').single();
        
        if (newIdeaData) {
          setBlogIdeas(prev => {
            const newIdeas = [...prev];
            newIdeas[index] = { id: newIdeaData.id, title: newIdeaData.title };
            return newIdeas;
          });
        }
      }
    } catch (error) {
      console.error('Error refreshing idea:', error);
    }
  };

  const resetBlogForm = () => {
    setBlogFormData({
      title: "",
      author_name: "",
      tags: "",
      excerpt: "",
      content: ""
    });
    setShowBlogIdeas(false);
    // Don't clear blogIdeas - keep them persisted
    setBlogImageFile(null);
  };

  const handleUpdateBlogPost = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedBlogPost) return;

    let imageUrl = selectedBlogPost.image_url;
    if (editBlogImageFile) {
      const fileExt = editBlogImageFile.name.split('.').pop();
      const filePath = `blog/${crypto.randomUUID()}.${fileExt}`;
      
      const { error: uploadError } = await supabase.storage
        .from('fundraising-images')
        .upload(filePath, editBlogImageFile);

      if (!uploadError) {
        const { data } = supabase.storage.from('fundraising-images').getPublicUrl(filePath);
        imageUrl = data.publicUrl;
      }
    }

    const { error } = await supabase.from('blog_posts').update({
      title: selectedBlogPost.title,
      author_name: selectedBlogPost.author_name || null,
      tags: selectedBlogPost.tags || [],
      excerpt: selectedBlogPost.excerpt,
      content: selectedBlogPost.content,
      image_url: imageUrl
    }).eq('id', selectedBlogPost.id);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Blog post updated!" });
      setEditBlogDialogOpen(false);
      setSelectedBlogPost(null);
      setEditBlogImageFile(null);
      fetchBlogPosts();
    }
  };

  const handleDeleteBlogPost = async (id: string) => {
    if (!confirm("Are you sure you want to delete this blog post?")) return;
    
    const { error } = await supabase.from('blog_posts').delete().eq('id', id);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Blog post deleted" });
      fetchBlogPosts();
    }
  };

  const handleAddShopItem = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    
    const amazonUrl = formData.get('amazon_url') as string;
    let finalAmazonUrl = amazonUrl;
    
    // Add affiliate tag if set
    if (amazonAffiliateTag && amazonUrl) {
      try {
        const url = new URL(amazonUrl);
        url.searchParams.set('tag', amazonAffiliateTag);
        finalAmazonUrl = url.toString();
      } catch (err) {
        toast({ title: "Invalid URL", description: "Please provide a valid Amazon URL", variant: "destructive" });
        return;
      }
    }

    // Validate Amazon URL (basic check)
    let itemStatus = 'active';
    if (amazonUrl) {
      try {
        const response = await fetch(amazonUrl, { method: 'HEAD', mode: 'no-cors' });
        // Note: Due to CORS, we can't actually check the response, but we try
      } catch (err) {
        console.warn('Could not validate Amazon URL');
      }
    }

    const { error } = await supabase.from('shop_items').insert({
      name: formData.get('name') as string,
      description: formData.get('description') as string,
      price: 0, // Set to 0 as we're using Amazon affiliate
      category: formData.get('category') as string,
      image_url: formData.get('image') as string || null,
      stock_quantity: 0, // Set to 0 as it's affiliate
      amazon_url: finalAmazonUrl,
      status: itemStatus
    });

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Shop item added!" });
      setShopDialogOpen(false);
      form.reset();
      fetchShopItems();
    }
  };

  const handleAddChangelog = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    const { error } = await supabase.from('changelog').insert({
      version: '', // Version is no longer used, using published_at date instead
      title: formData.get('title') as string,
      description: formData.get('description') as string,
      change_type: formData.get('type') as string,
      status: 'published',
      published_at: new Date().toISOString()
    });

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Changelog entry added!" });
      setChangelogDialogOpen(false);
      form.reset();
      fetchChangelog();
    }
  };

  const handleUpdateChangelog = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedChangelog) return;
    
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    
    const { error } = await supabase
      .from('changelog')
      .update({
        title: formData.get('title') as string,
        description: formData.get('description') as string,
        change_type: formData.get('type') as string,
      })
      .eq('id', selectedChangelog.id);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Changelog entry updated!" });
      setEditChangelogDialogOpen(false);
      setSelectedChangelog(null);
      fetchChangelog();
    }
  };

  const getChangeTypeBadge = (type: string) => {
    const variants: { [key: string]: "default" | "secondary" | "destructive" | "outline" } = {
      feature: "default",
      improvement: "secondary",
      bugfix: "outline",
      breaking: "destructive"
    };
    return <Badge variant={variants[type] || "default"}>{type}</Badge>;
  };

  const handleDeleteUser = async (id: string) => {
    if (!confirm("Are you sure you want to delete this user?")) return;
    
    const { error } = await supabase.from('profiles').delete().eq('id', id);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "User deleted" });
      fetchUsers();
    }
  };

  const handleDeleteMember = async (memberId: string) => {
    if (!confirm("Are you sure you want to delete this PTA member?")) return;
    
    if (!memberId) {
      toast({ title: "Error", description: "Member ID is missing", variant: "destructive" });
      return;
    }
    
    const { error } = await supabase.from('members').delete().eq('id', memberId);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "PTA member deleted" });
      fetchUsers();
    }
  };

  const handleDeleteSubscription = async (id: string) => {
    if (!confirm("Are you sure you want to delete this subscription?")) return;
    
    const { error } = await supabase.from('subscriptions').delete().eq('id', id);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Subscription deleted" });
      fetchSubscriptions();
    }
  };

  const handleDeleteShopItem = async (id: string) => {
    if (!confirm("Are you sure?")) return;
    const { error } = await supabase.from('shop_items').delete().eq('id', id);
    if (!error) {
      toast({ title: "Success", description: "Shop item deleted" });
      fetchShopItems();
    }
  };

  const handleDeleteChangelog = async (id: string) => {
    if (!confirm("Are you sure?")) return;
    const { error } = await supabase.from('changelog').delete().eq('id', id);
    if (!error) {
      toast({ title: "Success", description: "Changelog deleted" });
      fetchChangelog();
    }
  };

  const handleDeleteParent = async (parent: any) => {
    if (!confirm(`Are you sure you want to delete this parent account? This action is irreversible and will remove all their data (GDPR deletion request).`)) return;
    
    try {
      // Delete from parents table first
      const { error: parentError } = await supabase.from('parents').delete().eq('id', parent.id);
      
      if (parentError) throw parentError;
      
      toast({ title: "Success", description: "Parent account deleted successfully" });
      
      // Refresh parents list
      const { data } = await supabase.from('parents').select('*, ptas(name, school_name)');
      if (data) setParents(data);
    } catch (error: any) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    }
  };

  const handleUpdateParent = async () => {
    if (!selectedParent) return;
    
    const { error } = await supabase
      .from('parents')
      .update({
        full_name: editParentForm.full_name,
        email: editParentForm.email
      })
      .eq('id', selectedParent.id);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Parent updated successfully" });
      setEditParentDialogOpen(false);
      // Refresh parents list
      const { data } = await supabase.from('parents').select('*, ptas(name, school_name)');
      if (data) setParents(data);
    }
  };

  const handleApprove = async (id: string) => {
    try {
      // Get the idea to find submitter
      const idea = pendingIdeas.find(i => i.id === id);
      
      // Update status to approved
      const { error } = await supabase.from('fundraising_ideas').update({ status: 'approved' }).eq('id', id);
      if (error) throw error;
      
      // Send approval email if we have a submitter
      if (idea?.submitted_by) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('email')
          .eq('id', idea.submitted_by)
          .single();
          
        if (profile?.email) {
          const { data: { session } } = await supabase.auth.getSession();
          if (session) {
            await supabase.functions.invoke('send-email', {
              body: {
                templateName: 'idea_approved',
                recipients: profile.email,
                dynamicData: {
                  idea_title: idea.title
                }
              }
            });
          }
        }
      }
      
      toast({ title: "Success", description: "Idea approved and submitter notified!" });
      fetchIdeas();
    } catch (error: any) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    }
  };

  const openIdeaRejectDialog = (idea: any) => {
    setIdeaToReject(idea);
    setIdeaRejectionReason("");
    setIdeaRejectDialogOpen(true);
  };

  const handleRejectIdea = async () => {
    if (!ideaToReject || !ideaRejectionReason.trim()) {
      toast({ title: "Error", description: "Please provide a rejection reason", variant: "destructive" });
      return;
    }

    setIsRejectingIdea(true);
    
    try {
      // Get the submitter's email from profiles table if submitted_by exists
      let submitterEmail = null;
      if (ideaToReject.submitted_by) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('email')
          .eq('id', ideaToReject.submitted_by)
          .single();
        submitterEmail = profile?.email;
      }

      // Send rejection email if we have an email
      if (submitterEmail) {
        const { data: { session } } = await supabase.auth.getSession();
        if (session) {
          await supabase.functions.invoke('send-email', {
            body: {
              templateName: 'idea_rejected',
              recipients: submitterEmail,
              dynamicData: {
                idea_title: ideaToReject.title,
                rejection_reason: ideaRejectionReason
              }
            }
          });
        }
      }

      // Delete the idea
      const { error } = await supabase.from('fundraising_ideas').delete().eq('id', ideaToReject.id);
      if (error) throw error;

      toast({ title: "Success", description: "Idea rejected and submitter notified" });
      setIdeaRejectDialogOpen(false);
      setIdeaToReject(null);
      setIdeaRejectionReason("");
      fetchIdeas();
    } catch (error: any) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } finally {
      setIsRejectingIdea(false);
    }
  };

  const handleReject = (id: string) => {
    const idea = pendingIdeas.find(i => i.id === id);
    if (idea) {
      openIdeaRejectDialog(idea);
    }
  };

  const handleDelete = async (id: string) => {
    const { error } = await supabase.from('fundraising_ideas').delete().eq('id', id);
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Idea deleted" });
      fetchIdeas();
    }
  };

  const handlePublishIdea = async (id: string) => {
    const { error } = await supabase
      .from('fundraising_ideas')
      .update({ is_published: true })
      .eq('id', id);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Published", description: "Idea is now visible in the Library" });
      fetchIdeas();
    }
  };

  const handleUnpublishIdea = async (id: string) => {
    const { error } = await supabase
      .from('fundraising_ideas')
      .update({ is_published: false })
      .eq('id', id);
    
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Unpublished", description: "Idea is now hidden from the Library" });
      fetchIdeas();
    }
  };

  const handleUpdateIdea = async () => {
    if (!selectedIdea) return;

    setLoading(true);

    const { error } = await supabase
      .from('fundraising_ideas')
      .update({
        ...selectedIdea,
        // images is already in selectedIdea state (edited by admin)
      } as any)
      .eq('id', selectedIdea.id);

    setLoading(false);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Idea updated successfully!" });
      setEditIdeaDialogOpen(false);
      setSelectedIdea(null);
      fetchIdeas();
    }
  };

  const handleAddIdea = async () => {
    if (!formData.title || !formData.description || !formData.detailed_plan) {
      toast({ title: "Required fields", description: "Please fill in all required fields", variant: "destructive" });
      return;
    }

    setLoading(true);

    let imageUrl = null;
    if (imageFile) {
      const fileExt = imageFile.name.split('.').pop();
      const filePath = `${crypto.randomUUID()}.${fileExt}`;
      
      const { error: uploadError } = await supabase.storage
        .from('fundraising-images')
        .upload(filePath, imageFile);

      if (!uploadError) {
        const { data } = supabase.storage.from('fundraising-images').getPublicUrl(filePath);
        imageUrl = data.publicUrl;
      }
    }

    const { error } = await supabase
      .from('fundraising_ideas')
      .insert({
        ...formData,
        image_url: imageUrl,
        status: 'approved'
      });

    setLoading(false);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Idea added successfully!" });
      setAddDialogOpen(false);
      setImageFile(null);
      setFormData({
        title: "",
        description: "",
        detailed_plan: "",
        season: ["All Year"],
        location: ["Indoor"],
        type: [],
        estimated_helpers: 5,
        estimated_income: "£0",
        estimated_pricing: "£0"
      });
      fetchIdeas();
    }
  };

  const toggleSeason = (season: string) => {
    setFormData(prev => ({
      ...prev,
      season: prev.season.includes(season)
        ? prev.season.filter(s => s !== season)
        : [...prev.season, season]
    }));
  };

  const toggleLocation = (location: string) => {
    setFormData(prev => ({
      ...prev,
      location: prev.location.includes(location)
        ? prev.location.filter(l => l !== location)
        : [...prev.location, location]
    }));
  };

  const toggleType = (type: string) => {
    setFormData(prev => ({
      ...prev,
      type: prev.type.includes(type)
        ? prev.type.filter(t => t !== type)
        : [...prev.type, type]
    }));
  };

  const filteredUsers = users.filter(u => 
    u.email?.toLowerCase().includes(searchUsers.toLowerCase()) ||
    (u.full_name && u.full_name.toLowerCase().includes(searchUsers.toLowerCase())) ||
    u.ptas?.name?.toLowerCase().includes(searchUsers.toLowerCase()) ||
    u.ptas?.school_name?.toLowerCase().includes(searchUsers.toLowerCase()) ||
    u.role?.toLowerCase().includes(searchUsers.toLowerCase())
  );

  const filteredSubscriptions = subscriptions.filter(s => {
    const ptaName = s.ptas?.name || '';
    const matchesSearch = searchSubs === "" || ptaName.toLowerCase().includes(searchSubs.toLowerCase());
    const matchesPlan = filterPlan === "all" || s.plan === filterPlan;
    const matchesStatus = filterStatus === "all" || s.status === filterStatus;
    return matchesSearch && matchesPlan && matchesStatus;
  });

  // Filter subscriptions for different tabs
  const paidSubscriptions = subscriptions.filter(s => 
    s.status === 'active' && s.plan !== 'trial'
  ).filter(s => 
    !searchPaid || 
    s.ptas?.name?.toLowerCase().includes(searchPaid.toLowerCase()) ||
    s.ptas?.school_name?.toLowerCase().includes(searchPaid.toLowerCase())
  );

  const trialSubscriptions = subscriptions.filter(s => 
    s.plan === 'trial' || s.status === 'trial'
  ).filter(s => 
    !searchTrials || 
    s.ptas?.name?.toLowerCase().includes(searchTrials.toLowerCase()) ||
    s.ptas?.school_name?.toLowerCase().includes(searchTrials.toLowerCase())
  );

  const sponsoredPTAs = sponsorships.filter(s => s.status === 'active').filter(s => 
    !searchSponsored || 
    s.ptas?.name?.toLowerCase().includes(searchSponsored.toLowerCase()) ||
    s.ptas?.school_name?.toLowerCase().includes(searchSponsored.toLowerCase()) ||
    s.business_name?.toLowerCase().includes(searchSponsored.toLowerCase())
  );

  // Get PTAs that are inactive: no subscription, or subscription with inactive status
  const inactivePTAs = allPTAs.map(pta => {
    const subscription = subscriptions.find(s => s.pta_id === pta.id);
    const isInactive = !subscription || 
      ['inactive', 'cancelled', 'expired', 'trial_expired', 'replaced'].includes(subscription?.status);
    
    let inactiveReason = 'No subscription';
    if (subscription) {
      if (subscription.status === 'trial_expired') inactiveReason = 'Trial expired';
      else if (subscription.status === 'cancelled') inactiveReason = 'Cancelled';
      else if (subscription.status === 'expired') inactiveReason = 'Expired';
      else if (subscription.status === 'inactive') inactiveReason = 'Inactive';
      else if (subscription.status === 'replaced') inactiveReason = 'Replaced';
    }
    
    return {
      ...pta,
      subscription,
      isInactive,
      inactiveReason
    };
  }).filter(pta => pta.isInactive).filter(pta => 
    !searchInactive || 
    pta.name?.toLowerCase().includes(searchInactive.toLowerCase()) ||
    pta.school_name?.toLowerCase().includes(searchInactive.toLowerCase())
  );

  const handleExtendTrial = async () => {
    if (!selectedForManagement || !newTrialEndDate) return;

    // Calculate new scheduled deletion date (60 days after new trial end)
    const trialEndDate = new Date(newTrialEndDate);
    const deletionDate = new Date(trialEndDate);
    deletionDate.setDate(deletionDate.getDate() + 60);

    const { error } = await supabase
      .from('subscriptions')
      .update({ 
        trial_ends_at: newTrialEndDate,
        scheduled_deletion_at: deletionDate.toISOString()
      })
      .eq('id', selectedForManagement.id);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Trial extended successfully!" });
      setExtendTrialDialogOpen(false);
      setSelectedForManagement(null);
      setNewTrialEndDate("");
      fetchSubscriptions();
    }
  };

  const handleConvertToPaid = async () => {
    if (!selectedForManagement) return;

    const { error } = await supabase
      .from('subscriptions')
      .update({ 
        plan: convertToPlan as any,
        status: 'active'
      })
      .eq('id', selectedForManagement.id);

    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Converted to paid plan successfully!" });
      setConvertDialogOpen(false);
      setSelectedForManagement(null);
      fetchSubscriptions();
    }
  };

  const handleConvertSponsoredToPaid = async (sponsorship: any) => {
    if (!sponsorship.pta_id) return;

    // Find or create subscription for this PTA
    const { data: existingSub } = await supabase
      .from('subscriptions')
      .select('*')
      .eq('pta_id', sponsorship.pta_id)
      .single();

    if (existingSub) {
      const { error } = await supabase
        .from('subscriptions')
        .update({ plan: convertToPlan as any, status: 'active' })
        .eq('id', existingSub.id);

      if (error) {
        toast({ title: "Error", description: error.message, variant: "destructive" });
        return;
      }
    }

    // Deactivate sponsorship
    const { error: sponsorError } = await supabase
      .from('sponsorships')
      .update({ status: 'inactive' })
      .eq('id', sponsorship.id);

    if (sponsorError) {
      toast({ title: "Error", description: sponsorError.message, variant: "destructive" });
    } else {
      toast({ title: "Success", description: "Converted sponsored PTA to paid plan!" });
      setConvertDialogOpen(false);
      setSelectedForManagement(null);
      fetchSubscriptions();
      fetchSponsorships();
    }
  };

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <div>
        <h1 className="text-4xl font-bold text-foreground">
          Site Admin
        </h1>
          <p className="text-muted-foreground mt-2">Manage all aspects of the platform</p>
        </div>
      </div>

      {permissionsLoading ? (
        <div className="flex items-center justify-center p-8">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <span className="ml-2 text-muted-foreground">Loading permissions...</span>
        </div>
      ) : (
      <Tabs defaultValue={currentUserAllowedTabs.length > 0 ? currentUserAllowedTabs[0] : "summary"} className="w-full">
        <TabsList className="grid grid-cols-4 md:grid-cols-7 gap-1 h-auto">
          {ALL_TABS.filter(tab => {
            // Primary admin sees all tabs
            if (isPrimaryAdmin) return true;
            // "admins" tab is only for primary admin
            if (tab.value === 'admins') return false;
            // Other admins see only their allowed tabs
            return currentUserAllowedTabs.includes(tab.value);
          }).map(tab => (
            <TabsTrigger key={tab.value} value={tab.value} className="py-2">
              <tab.icon className="h-4 w-4 mr-2" />{tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {/* Summary Tab */}
        <TabsContent value="summary" className="space-y-4">
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
            <Card>
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">Total Users</CardTitle>
                <Users className="h-4 w-4 text-muted-foreground" />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">{summaryStats.totalUsers}</div>
                <p className="text-xs text-muted-foreground">PTA members & parents combined</p>
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">PTAs</CardTitle>
                <Building className="h-4 w-4 text-muted-foreground" />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">{summaryStats.totalPTAs}</div>
                <p className="text-xs text-muted-foreground">Active organizations</p>
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">Active Subscriptions</CardTitle>
                <Receipt className="h-4 w-4 text-muted-foreground" />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">{summaryStats.activeSubscriptions}</div>
                <p className="text-xs text-muted-foreground">Paying customers</p>
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">Active Sponsorships</CardTitle>
                <Star className="h-4 w-4 text-muted-foreground" />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">{summaryStats.activeSponsorships}</div>
                <p className="text-xs text-muted-foreground">Business sponsors</p>
              </CardContent>
            </Card>
          </div>

          <div className="grid gap-4 md:grid-cols-2">
            <Card>
              <CardHeader>
                <CardTitle>Outstanding Requests</CardTitle>
                <CardDescription>Items requiring attention</CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="flex items-center justify-between p-3 rounded-lg">
                  <div className="flex items-center gap-3">
                    <Ticket className="h-5 w-5 text-primary" />
                    <span className="font-medium">Open Support Tickets</span>
                  </div>
                  <Badge variant={summaryStats.openTickets > 0 ? "destructive" : "secondary"}>
                    {summaryStats.openTickets}
                  </Badge>
                </div>
                
                <div className="flex items-center justify-between p-3 rounded-lg">
                  <div className="flex items-center gap-3">
                    <AlertTriangle className="h-5 w-5 text-primary" />
                    <span className="font-medium">Reported Forum Posts</span>
                  </div>
                  <Badge variant={summaryStats.reportedPosts > 0 ? "destructive" : "secondary"}>
                    {summaryStats.reportedPosts}
                  </Badge>
                </div>
                
                <div className="flex items-center justify-between p-3 rounded-lg">
                  <div className="flex items-center gap-3">
                    <Lightbulb className="h-5 w-5 text-primary" />
                    <span className="font-medium">Library Submissions</span>
                  </div>
                  <Badge variant={summaryStats.pendingLibrary > 0 ? "destructive" : "secondary"}>
                    {summaryStats.pendingLibrary}
                  </Badge>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Content Statistics</CardTitle>
                <CardDescription>Platform content overview</CardDescription>
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="flex items-center justify-between p-3">
                  <div className="flex items-center gap-3">
                    <ShoppingBag className="h-5 w-5 text-primary" />
                    <span className="font-medium">Shop Items</span>
                  </div>
                  <Badge variant="secondary">{summaryStats.totalShopItems}</Badge>
                </div>
                <div className="flex items-center justify-between p-3">
                  <div className="flex items-center gap-3">
                    <FileText className="h-5 w-5 text-primary" />
                    <span className="font-medium">Blog Posts</span>
                  </div>
                  <Badge variant="secondary">{blogPosts.length}</Badge>
                </div>
                <div className="flex items-center justify-between p-3">
                  <div className="flex items-center gap-3">
                    <Lightbulb className="h-5 w-5 text-primary" />
                    <span className="font-medium">Fundraising Ideas</span>
                  </div>
                  <Badge variant="secondary">{approvedIdeas.length + pendingIdeas.length}</Badge>
                </div>
                <div className="flex items-center justify-between p-3">
                  <div className="flex items-center gap-3">
                    <Ticket className="h-5 w-5 text-primary" />
                    <span className="font-medium">Support Tickets</span>
                  </div>
                  <Badge variant="secondary">{tickets.length}</Badge>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="grid gap-4 md:grid-cols-2">
            <Card>
              <CardHeader>
                <CardTitle>Subscription Distribution</CardTitle>
                <CardDescription>Active subscriptions by plan</CardDescription>
              </CardHeader>
              <CardContent>
                <ChartContainer
                  config={{
                    subscriptions: {
                      label: "Subscriptions",
                      color: "hsl(var(--primary))",
                    },
                  }}
                  className="min-h-[280px] w-full"
                >
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                      data={[
                        { plan: "Basic", count: subscriptions.filter(s => s.plan === 'basic' && s.status === 'active').length },
                        { plan: "Standard", count: subscriptions.filter(s => s.plan === 'standard' && s.status === 'active').length }
                      ]}
                    >
                      <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
                      <XAxis dataKey="plan" className="text-xs" />
                      <YAxis className="text-xs" />
                      <ChartTooltip content={<ChartTooltipContent />} />
                      <Bar dataKey="count" fill="hsl(var(--primary))" radius={[8, 8, 0, 0]} />
                    </BarChart>
                  </ResponsiveContainer>
                </ChartContainer>
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader>
                <CardTitle>Recent Activity</CardTitle>
                <CardDescription>Latest platform events</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {recentActivity.length === 0 ? (
                    <p className="text-sm text-muted-foreground">No recent activity</p>
                  ) : (
                    recentActivity.map((activity, index) => (
                      <div key={index} className="flex items-center gap-3 p-2 rounded-lg">
                        <div className="flex-shrink-0">
                          {activity.icon === 'Building' && <Building className="h-4 w-4 text-primary" />}
                          {activity.icon === 'Receipt' && <Receipt className="h-4 w-4 text-primary" />}
                          {activity.icon === 'Lightbulb' && <Lightbulb className="h-4 w-4 text-primary" />}
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium truncate">{activity.title}</p>
                          <p className="text-xs text-muted-foreground flex items-center gap-1">
                            <Clock className="h-3 w-3" />
                            {new Date(activity.timestamp).toLocaleDateString()}
                          </p>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </CardContent>
            </Card>
          </div>
        </TabsContent>

        {/* Library Tab */}
        <TabsContent value="library" className="space-y-4">
          <Tabs defaultValue="approved" className="w-full">
            <TabsList>
              <TabsTrigger value="approved">Approved ({approvedIdeas.length})</TabsTrigger>
              <TabsTrigger value="pending">Pending ({pendingIdeas.length})</TabsTrigger>
            </TabsList>

            <TabsContent value="approved" className="space-y-4">
              <div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold">Approved Ideas</h2>
                <Dialog open={addDialogOpen} onOpenChange={setAddDialogOpen}>
                  <DialogTrigger asChild>
                    <Button><Plus className="h-4 w-4 mr-2" />Add New Idea</Button>
                  </DialogTrigger>
                  <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                    <DialogHeader>
                      <DialogTitle>Submit Your Fundraising Idea</DialogTitle>
                      <DialogDescription>Share a successful fundraising idea with the community</DialogDescription>
                    </DialogHeader>
                    <div className="space-y-4">
                      <div>
                        <Label htmlFor="title">Title *</Label>
                        <Input 
                          id="title" 
                          value={formData.title} 
                          onChange={(e) => setFormData({ ...formData, title: e.target.value })} 
                          placeholder="e.g., Summer Fair" 
                        />
                      </div>
                      <div>
                        <Label htmlFor="description">Short Description *</Label>
                        <Textarea 
                          id="description" 
                          value={formData.description} 
                          onChange={(e) => setFormData({ ...formData, description: e.target.value })} 
                          placeholder="Brief overview of the fundraising idea" 
                          rows={3} 
                        />
                      </div>
                      <div>
                        <Label htmlFor="detailed_plan">Detailed Plan *</Label>
                        <Textarea 
                          id="detailed_plan" 
                          value={formData.detailed_plan} 
                          onChange={(e) => setFormData({ ...formData, detailed_plan: e.target.value })} 
                          placeholder="Step-by-step guide on how to execute this idea" 
                          rows={6} 
                        />
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <Label>Type (select all that apply)</Label>
                          <div className="space-y-2 mt-2">
                            {['Event', 'Stall'].map((type) => (
                              <div key={type} className="flex items-center space-x-2">
                                <Checkbox 
                                  id={`type-${type}`} 
                                  checked={formData.type.includes(type)} 
                                  onCheckedChange={() => toggleType(type)} 
                                />
                                <label htmlFor={`type-${type}`} className="text-sm cursor-pointer">{type}</label>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div>
                          <Label>Season (select all that apply)</Label>
                          <div className="space-y-2 mt-2">
                            {['Spring', 'Summer', 'Autumn', 'Winter', 'All Year'].map((season) => (
                              <div key={season} className="flex items-center space-x-2">
                                <Checkbox 
                                  id={`season-${season}`} 
                                  checked={formData.season.includes(season)} 
                                  onCheckedChange={() => toggleSeason(season)} 
                                />
                                <label htmlFor={`season-${season}`} className="text-sm cursor-pointer">{season}</label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div>
                        <Label>Location (select all that apply)</Label>
                        <div className="grid grid-cols-3 gap-4 mt-2">
                          {['Indoor', 'Outdoor', 'Online'].map((location) => (
                            <div key={location} className="flex items-center space-x-2">
                              <Checkbox 
                                id={`location-${location}`} 
                                checked={formData.location.includes(location)} 
                                onCheckedChange={() => toggleLocation(location)} 
                              />
                              <label htmlFor={`location-${location}`} className="text-sm cursor-pointer">{location}</label>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 gap-4">
                        <div>
                          <Label htmlFor="helpers">Estimated Helpers</Label>
                          <Input
                            id="helpers"
                            type="number"
                            value={formData.estimated_helpers}
                            onChange={(e) => setFormData({ ...formData, estimated_helpers: parseInt(e.target.value) || 0 })}
                            placeholder="e.g., 5"
                          />
                        </div>
                        <div>
                          <Label htmlFor="income">Estimated Income</Label>
                          <Input
                            id="income"
                            value={formData.estimated_income}
                            onChange={(e) => setFormData({ ...formData, estimated_income: e.target.value })}
                            placeholder="£0"
                          />
                        </div>
                        <div>
                          <Label htmlFor="pricing">Estimated Pricing</Label>
                          <Input
                            id="pricing"
                            value={formData.estimated_pricing}
                            onChange={(e) => setFormData({ ...formData, estimated_pricing: e.target.value })}
                            placeholder="£0"
                          />
                        </div>
                      </div>
                      <div>
                        <Label htmlFor="image">Image (Optional)</Label>
                        <div 
                          className={`mt-2 border-2 border-dashed rounded-lg p-6 transition-colors ${
                            imageFile ? 'border-primary bg-primary/5' : 'border-border hover:border-primary/50'
                          }`}
                        >
                          <div className="text-center">
                            <Upload className="h-8 w-8 mx-auto mb-2 text-muted-foreground" />
                            <p className="text-sm text-muted-foreground mb-2">
                              Click to upload image
                            </p>
                            <p className="text-xs text-muted-foreground mb-2">JPG, PNG (Max 10MB)</p>
                            <Input 
                              id="image"
                              type="file" 
                              accept="image/*" 
                              onChange={(e) => setImageFile(e.target.files?.[0] || null)} 
                              className="cursor-pointer"
                            />
                            {imageFile && (
                              <p className="text-sm text-primary mt-2">Selected: {imageFile.name}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <Button onClick={handleAddIdea} disabled={loading} className="w-full">
                        {loading ? "Submitting..." : "Submit Idea"}
                      </Button>
                    </div>
                  </DialogContent>
                </Dialog>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                {approvedIdeas.map((idea) => (
                  <Card key={idea.id}>
                    <CardContent className="p-4">
                      <div className="flex gap-4">
                        {idea.image_url && (
                          <div className="flex-shrink-0">
                            <img 
                              src={idea.image_url} 
                              alt={idea.title} 
                              className="w-24 h-24 object-cover rounded-lg"
                            />
                          </div>
                        )}
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1">
                            <h3 className="font-semibold text-lg">{idea.title}</h3>
                            <Badge variant={idea.is_published ? "default" : "secondary"} className="text-xs">
                              {idea.is_published ? "Published" : "Draft"}
                            </Badge>
                          </div>
                          <p className="text-sm text-muted-foreground mb-3 line-clamp-2">{idea.description}</p>
                          <div className="flex items-center justify-end gap-1">
                            {idea.is_published ? (
                              <Button 
                                size="icon" 
                                variant="ghost" 
                                onClick={() => handleUnpublishIdea(idea.id)}
                                title="Unpublish"
                                className="h-8 w-8 text-foreground"
                              >
                                <EyeOff className="h-4 w-4" />
                              </Button>
                            ) : (
                              <Button 
                                size="icon" 
                                variant="ghost" 
                                onClick={() => handlePublishIdea(idea.id)}
                                title="Publish"
                                className="h-8 w-8 text-foreground"
                              >
                                <Globe className="h-4 w-4" />
                              </Button>
                            )}
                            <Button 
                              size="icon" 
                              variant="ghost" 
                            onClick={() => {
                                setSelectedIdea(idea);
                                setEditIdeaDialogOpen(true);
                              }}
                              className="h-8 w-8 text-foreground"
                            >
                              <Edit className="h-4 w-4" />
                            </Button>
                            <Button 
                              size="icon" 
                              variant="ghost" 
                              onClick={() => handleDelete(idea.id)} 
                              className="h-8 w-8 text-foreground"
                            >
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </TabsContent>

            <TabsContent value="pending" className="space-y-4">
              <h2 className="text-xl font-semibold">Pending Review ({pendingIdeas.length})</h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {pendingIdeas.map((idea) => (
                  <Card key={idea.id} className="flex flex-col h-[300px]">
                    <CardHeader className="flex-shrink-0">
                      <CardTitle className="text-base line-clamp-1">{idea.title}</CardTitle>
                      <CardDescription className="h-10 overflow-y-auto text-sm">
                        {idea.description}
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="flex-1 flex flex-col justify-end space-y-3">
                      <Dialog>
                        <DialogTrigger asChild>
                          <Button variant="outline" size="sm" className="w-full">
                            <Eye className="h-4 w-4 mr-2" />
                            View Details
                          </Button>
                        </DialogTrigger>
                        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                          <DialogHeader>
                            <DialogTitle>{idea.title}</DialogTitle>
                          </DialogHeader>
                          <div className="space-y-4">
                            {idea.image_url && (
                              <img 
                                src={idea.image_url} 
                                alt={idea.title}
                                className="w-full h-48 object-cover rounded-lg"
                              />
                            )}
                            <div>
                              <h4 className="font-semibold mb-2">Description</h4>
                              <p className="text-sm text-muted-foreground">{idea.description}</p>
                            </div>
                            <div>
                              <h4 className="font-semibold mb-2">Detailed Plan</h4>
                              <p className="text-sm text-muted-foreground whitespace-pre-wrap">{idea.detailed_plan}</p>
                            </div>
                            <div className="grid grid-cols-2 gap-3">
                              <div>
                                <h4 className="font-semibold text-sm mb-1">Season</h4>
                                <div className="flex flex-wrap gap-1">
                                  {idea.season.map((s: string) => (
                                    <Badge key={s} variant="secondary">{s}</Badge>
                                  ))}
                                </div>
                              </div>
                              <div>
                                <h4 className="font-semibold text-sm mb-1">Location</h4>
                                <div className="flex flex-wrap gap-1">
                                  {idea.location.map((l: string) => (
                                    <Badge key={l} variant="outline">{l}</Badge>
                                  ))}
                                </div>
                              </div>
                            </div>
                            <div className="space-y-2">
                              <div className="flex items-center gap-2 text-sm">
                                <Users className="h-4 w-4" />
                                <span>Helpers needed: {idea.estimated_helpers}</span>
                              </div>
                              <div className="flex items-center gap-2 text-sm">
                                <DollarSign className="h-4 w-4" />
                                <span>Est. Income: {idea.estimated_income}</span>
                              </div>
                              <div className="flex items-center gap-2 text-sm">
                                <Tag className="h-4 w-4" />
                                <span>Est. Pricing: {idea.estimated_pricing}</span>
                              </div>
                            </div>
                            
                            {/* Supporting Images from User */}
                            {idea.images && idea.images.length > 0 && (
                              <div>
                                <h4 className="font-semibold mb-2">Supporting Images from User</h4>
                                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                                  {idea.images.map((img: string, idx: number) => (
                                    <img 
                                      key={idx}
                                      src={img} 
                                      alt={`Supporting image ${idx + 1}`}
                                      className="w-full h-24 object-cover rounded-lg border"
                                    />
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </DialogContent>
                      </Dialog>
                      
                      <div className="flex gap-2">
                        <Button 
                          onClick={() => handleApprove(idea.id)} 
                          size="sm"
                          className="flex-1"
                        >
                          <Check className="h-4 w-4 mr-1" />
                          Approve
                        </Button>
                        <Button 
                          onClick={() => handleReject(idea.id)} 
                          variant="destructive" 
                          size="sm"
                          className="flex-1"
                        >
                          <X className="h-4 w-4 mr-1" />
                          Reject
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </TabsContent>
          </Tabs>
        </TabsContent>

        {/* Users Tab */}
        <TabsContent value="users" className="space-y-4">
          <Tabs defaultValue="pta-members" className="w-full">
            <TabsList>
              <TabsTrigger value="pta-members">
                <Users className="h-4 w-4 mr-2" />
                PTA Members ({users.length})
              </TabsTrigger>
              <TabsTrigger value="parents">
                <Users className="h-4 w-4 mr-2" />
                Parents ({parents.length})
              </TabsTrigger>
            </TabsList>

            {/* PTA Members Tab */}
            <TabsContent value="pta-members" className="space-y-4">
              <div className="flex gap-2 mb-4">
                <div className="relative flex-1">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input placeholder="Search PTA members..." className="pl-9" value={searchUsers} onChange={(e) => setSearchUsers(e.target.value)} />
                </div>
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {filteredUsers.map((user) => (
                  <Card key={user.id}>
                    <CardHeader>
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <CardTitle className="text-base">{user.full_name || 'No name'}</CardTitle>
                          <CardDescription className="text-sm">{user.email}</CardDescription>
                          {user.ptas && (
                            <p className="text-xs text-muted-foreground mt-1">
                              {user.ptas.name} - {user.ptas.school_name}
                            </p>
                          )}
                          {user.role && (
                            <Badge variant="outline" className="text-xs mt-2">{user.role}</Badge>
                          )}
                          {user.is_pta_admin && (
                            <Badge variant="default" className="text-xs mt-2 ml-1">PTA Admin</Badge>
                          )}
                          {user.user_roles && user.user_roles.length > 0 && (
                            <div className="flex flex-wrap gap-1 mt-2">
                              {user.user_roles.map((ur: any, idx: number) => (
                                <Badge key={idx} variant="outline" className="text-xs">
                                  {ur.role.split('_').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')}
                                </Badge>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="flex gap-1">
                          <Button size="sm" variant="ghost" onClick={() => {
                            setSelectedUser(user);
                            setEditUserDialogOpen(true);
                          }}>
                            <Edit className="h-4 w-4" />
                          </Button>
                          <Button size="sm" variant="ghost" onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDeleteMember(user.id); }}><Trash2 className="h-4 w-4 text-foreground" /></Button>
                        </div>
                      </div>
                    </CardHeader>
                  </Card>
                ))}
              </div>
            </TabsContent>

            {/* Parents Tab */}
            <TabsContent value="parents" className="space-y-4">
              <div className="flex gap-2 mb-4">
                <div className="relative flex-1">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input placeholder="Search parents..." className="pl-9" value={searchParents} onChange={(e) => setSearchParents(e.target.value)} />
                </div>
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {parents
                  .filter(parent => 
                    parent.full_name?.toLowerCase().includes(searchParents.toLowerCase()) ||
                    parent.email?.toLowerCase().includes(searchParents.toLowerCase()) ||
                    parent.ptas?.name?.toLowerCase().includes(searchParents.toLowerCase()) ||
                    parent.ptas?.school_name?.toLowerCase().includes(searchParents.toLowerCase())
                  )
                  .map((parent) => (
                    <Card key={parent.id}>
                      <CardHeader>
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <CardTitle className="text-base">{parent.full_name || 'No name'}</CardTitle>
                            <CardDescription className="text-sm">{parent.email}</CardDescription>
                            {parent.ptas && (
                              <p className="text-xs text-muted-foreground mt-1">
                                {parent.ptas.name} - {parent.ptas.school_name}
                              </p>
                            )}
                            <p className="text-xs text-muted-foreground mt-2">
                              Registered: {new Date(parent.created_at).toLocaleDateString()}
                            </p>
                          </div>
                          <div className="flex gap-1">
                            <Button size="sm" variant="ghost" onClick={() => {
                              setSelectedParent(parent);
                              setEditParentForm({
                                full_name: parent.full_name || "",
                                email: parent.email || ""
                              });
                              setEditParentDialogOpen(true);
                            }}>
                              <Edit className="h-4 w-4" />
                            </Button>
                            <Button 
                              size="sm" 
                              variant="ghost" 
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleDeleteParent(parent);
                              }}
                            >
                              <Trash2 className="h-4 w-4 text-foreground" />
                            </Button>
                          </div>
                        </div>
                      </CardHeader>
                    </Card>
                  ))}
              </div>
              {parents.filter(parent => 
                parent.full_name?.toLowerCase().includes(searchParents.toLowerCase()) ||
                parent.email?.toLowerCase().includes(searchParents.toLowerCase()) ||
                parent.ptas?.name?.toLowerCase().includes(searchParents.toLowerCase()) ||
                parent.ptas?.school_name?.toLowerCase().includes(searchParents.toLowerCase())
              ).length === 0 && (
                <Card>
                  <CardContent className="pt-6 text-center text-muted-foreground">
                    No parents found matching your search
                  </CardContent>
                </Card>
              )}
            </TabsContent>
          </Tabs>
        </TabsContent>

        {/* Subscriptions Tab */}
        <TabsContent value="subscriptions" className="space-y-4">
          <Tabs defaultValue="paid" className="w-full">
            <TabsList>
              <TabsTrigger value="paid">
                <CreditCard className="h-4 w-4 mr-2" />
                Paid Plans ({paidSubscriptions.length})
              </TabsTrigger>
              <TabsTrigger value="trials">
                <Star className="h-4 w-4 mr-2" />
                Trials ({trialSubscriptions.length})
              </TabsTrigger>
              <TabsTrigger value="sponsored">
                <Building className="h-4 w-4 mr-2" />
                Sponsored ({sponsoredPTAs.length})
              </TabsTrigger>
              <TabsTrigger value="promo-codes">
                <Tag className="h-4 w-4 mr-2" />
                Promo Codes ({promoCodes.length})
              </TabsTrigger>
              <TabsTrigger value="inactive">
                <X className="h-4 w-4 mr-2" />
                Inactive PTAs ({inactivePTAs.length})
              </TabsTrigger>
            </TabsList>

            {/* Paid Plans Tab */}
            <TabsContent value="paid" className="space-y-4">
              <div className="relative mb-4">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                  placeholder="Search paid plans..."
                  value={searchPaid}
                  onChange={(e) => setSearchPaid(e.target.value)}
                  className="pl-10"
                />
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {paidSubscriptions.map((sub) => (
                  <Card key={sub.id}>
                    <CardHeader>
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <CardTitle className="text-base">{sub.ptas?.name || 'Unknown PTA'}</CardTitle>
                          <CardDescription className="text-sm">{sub.ptas?.school_name || 'No school'}</CardDescription>
                          {sub.ptas?.charity_number && (
                            <p className="text-xs text-muted-foreground mt-1">Charity: {sub.ptas.charity_number}</p>
                          )}
                          <div className="flex gap-2 mt-2">
                            <Badge variant="default">{sub.status}</Badge>
                            <Badge variant="outline">{sub.plan}</Badge>
                          </div>
                          {sub.expires_at && (
                            <p className="text-xs text-muted-foreground mt-2">
                              Expires: {new Date(sub.expires_at).toLocaleDateString()}
                            </p>
                          )}
                        </div>
                        <div className="flex gap-1">
                          <Button size="sm" variant="ghost" onClick={() => {
                            setSelectedSub(sub);
                            setEditSubDialogOpen(true);
                          }}>
                            <Edit className="h-4 w-4" />
                          </Button>
                        </div>
                      </div>
                    </CardHeader>
                  </Card>
                ))}
              </div>
            </TabsContent>

            {/* Trials Tab */}
            <TabsContent value="trials" className="space-y-4">
              <div className="relative mb-4">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                  placeholder="Search trials..."
                  value={searchTrials}
                  onChange={(e) => setSearchTrials(e.target.value)}
                  className="pl-10"
                />
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {trialSubscriptions.map((sub) => (
                  <Card key={sub.id}>
                    <CardHeader>
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <CardTitle className="text-base">{sub.ptas?.name || 'Unknown PTA'}</CardTitle>
                          <CardDescription className="text-sm">{sub.ptas?.school_name || 'No school'}</CardDescription>
                          <div className="flex gap-2 mt-2">
                            <Badge variant="secondary">Trial</Badge>
                          </div>
                          <div className="text-xs text-muted-foreground mt-2 space-y-1">
                            <p>Started: {new Date(sub.created_at).toLocaleDateString()}</p>
                            {sub.trial_ends_at && (
                              <p>Ends: {new Date(sub.trial_ends_at).toLocaleDateString()}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent className="space-y-2">
                      <Button 
                        size="sm" 
                        variant="outline" 
                        className="w-full"
                        onClick={() => {
                          setSelectedForManagement(sub);
                          setExtendTrialDialogOpen(true);
                        }}
                      >
                        Extend Trial
                      </Button>
                      <Button 
                        size="sm" 
                        className="w-full"
                        onClick={() => {
                          setSelectedForManagement(sub);
                          setConvertDialogOpen(true);
                        }}
                      >
                        Convert to Paid
                      </Button>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </TabsContent>

            {/* Sponsored Tab */}
            <TabsContent value="sponsored" className="space-y-4">
              <div className="relative mb-4">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                  placeholder="Search sponsored PTAs..."
                  value={searchSponsored}
                  onChange={(e) => setSearchSponsored(e.target.value)}
                  className="pl-10"
                />
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {sponsoredPTAs.map((sponsorship) => (
                  <Card key={sponsorship.id}>
                    <CardHeader>
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <CardTitle className="text-base">{sponsorship.ptas?.name || 'Unknown PTA'}</CardTitle>
                          <CardDescription className="text-sm">{sponsorship.ptas?.school_name || 'No school'}</CardDescription>
                          <div className="mt-3 space-y-2">
                            <div className="text-sm">
                              <span className="font-semibold">Business:</span> {sponsorship.business_name}
                            </div>
                            <div className="text-sm">
                              <span className="font-semibold">Contact:</span> {sponsorship.contact_first_name} {sponsorship.contact_last_name}
                            </div>
                            <div className="text-sm">
                              <span className="font-semibold">Email:</span> {sponsorship.contact_email}
                            </div>
                            <div className="text-xs text-muted-foreground space-y-1 mt-2">
                              <p>Started: {new Date(sponsorship.start_date).toLocaleDateString()}</p>
                              <p>Ends: {new Date(sponsorship.end_date).toLocaleDateString()}</p>
                            </div>
                            <Badge variant="outline">{sponsorship.sponsored_plan}</Badge>
                          </div>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <Button 
                        size="sm" 
                        className="w-full"
                        onClick={() => {
                          setSelectedForManagement(sponsorship);
                          setConvertDialogOpen(true);
                        }}
                      >
                        Convert to Paid Plan
                      </Button>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </TabsContent>

            {/* Inactive PTAs Tab */}
            <TabsContent value="inactive" className="space-y-4">
              <div className="relative mb-4">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                  placeholder="Search inactive PTAs..."
                  value={searchInactive}
                  onChange={(e) => setSearchInactive(e.target.value)}
                  className="pl-10"
                />
              </div>
              {inactivePTAs.length === 0 ? (
                <Card>
                  <CardContent className="p-6 text-center text-muted-foreground">
                    No inactive PTAs found.
                  </CardContent>
                </Card>
              ) : (
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {inactivePTAs.map((pta) => (
                    <Card key={pta.id}>
                      <CardHeader>
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <CardTitle className="text-base">{pta.name || 'Unknown PTA'}</CardTitle>
                            <CardDescription className="text-sm">{pta.school_name || 'No school'}</CardDescription>
                            {pta.charity_number && (
                              <p className="text-xs text-muted-foreground mt-1">Charity: {pta.charity_number}</p>
                            )}
                            <div className="flex gap-2 mt-2">
                              <Badge variant="destructive">{pta.inactiveReason}</Badge>
                              {pta.subscription?.plan && <Badge variant="outline">{pta.subscription.plan}</Badge>}
                            </div>
                            {pta.subscription?.expires_at && (
                              <p className="text-xs text-muted-foreground mt-2">
                                Expired: {new Date(pta.subscription.expires_at).toLocaleDateString()}
                              </p>
                            )}
                            {pta.subscription?.trial_ends_at && pta.inactiveReason === 'Trial expired' && (
                              <p className="text-xs text-muted-foreground mt-2">
                                Trial ended: {new Date(pta.subscription.trial_ends_at).toLocaleDateString()}
                              </p>
                            )}
                          </div>
                          <div className="flex gap-1">
                            {pta.subscription && (
                              <Button size="sm" variant="ghost" onClick={() => {
                                setSelectedSub(pta.subscription);
                                setEditSubDialogOpen(true);
                              }}>
                                <Edit className="h-4 w-4 text-black" />
                              </Button>
                            )}
                            <Button size="sm" variant="ghost" onClick={async () => {
                              if (!confirm(`Are you sure you want to delete ${pta.name}? This will remove all associated data.`)) return;
                              
                              // Delete subscription first if exists
                              if (pta.subscription) {
                                await supabase.from('subscriptions').delete().eq('id', pta.subscription.id);
                              }
                              
                              // Delete the PTA
                              const { error } = await supabase.from('ptas').delete().eq('id', pta.id);
                              if (error) {
                                toast({ title: "Error", description: "Failed to delete PTA: " + error.message, variant: "destructive" });
                              } else {
                                toast({ title: "Success", description: "PTA deleted successfully" });
                                fetchAllPTAs();
                                fetchSubscriptions();
                              }
                            }}>
                              <Trash2 className="h-4 w-4 text-black" />
                            </Button>
                          </div>
                        </div>
                      </CardHeader>
                    </Card>
                  ))}
                </div>
              )}
            </TabsContent>

            {/* Promo Codes Tab */}
            <TabsContent value="promo-codes" className="space-y-4">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold">Promo Codes</h3>
                <Dialog open={promoCodeDialogOpen} onOpenChange={setPromoCodeDialogOpen}>
                  <DialogTrigger asChild>
                    <Button><Plus className="h-4 w-4 mr-2" />Add Promo Code</Button>
                  </DialogTrigger>
                  <DialogContent>
                    <DialogHeader>
                      <DialogTitle>Create Promo Code</DialogTitle>
                    </DialogHeader>
                    <form onSubmit={handleAddPromoCode} className="space-y-4">
                      <div>
                        <Label>Code</Label>
                        <Input name="code" required placeholder="e.g., EARLY2025" />
                      </div>
                      <div>
                        <Label>Trial Days</Label>
                        <Input name="trial_days" type="number" defaultValue={180} min={1} required />
                      </div>
                      <div>
                        <Label>Max Uses (leave empty for unlimited)</Label>
                        <Input name="max_uses" type="number" min={1} />
                      </div>
                      <div>
                        <Label>Expires At (optional)</Label>
                        <Input name="expires_at" type="date" />
                      </div>
                      <div>
                        <Label>Description</Label>
                        <Input name="description" placeholder="Internal note about this code" />
                      </div>
                      <Button type="submit" className="w-full">Create Promo Code</Button>
                    </form>
                  </DialogContent>
                </Dialog>
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {promoCodes.map((code) => (
                  <Card key={code.id}>
                    <CardHeader>
                      <div className="flex items-start justify-between">
                        <div>
                          <CardTitle className="text-base font-mono">{code.code}</CardTitle>
                          <CardDescription>{code.description || 'No description'}</CardDescription>
                        </div>
                        <Badge variant={code.is_active ? "default" : "secondary"}>
                          {code.is_active ? 'Active' : 'Inactive'}
                        </Badge>
                      </div>
                    </CardHeader>
                    <CardContent className="space-y-2">
                      <div className="text-sm space-y-1">
                        <p><strong>Trial Days:</strong> {code.trial_days}</p>
                        <p><strong>Uses:</strong> {code.times_used}{code.max_uses ? ` / ${code.max_uses}` : ' (unlimited)'}</p>
                        {code.expires_at && (
                          <p><strong>Expires:</strong> {new Date(code.expires_at).toLocaleDateString()}</p>
                        )}
                      </div>
                      <div className="flex gap-2 pt-2">
                        <Button size="sm" variant="outline" onClick={() => handleTogglePromoCode(code.id, code.is_active)}>
                          {code.is_active ? 'Deactivate' : 'Activate'}
                        </Button>
                        <Button size="sm" variant="destructive" onClick={() => handleDeletePromoCode(code.id)}>
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </TabsContent>
          </Tabs>

          {/* Extend Trial Dialog */}
          <Dialog open={extendTrialDialogOpen} onOpenChange={setExtendTrialDialogOpen}>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Extend Trial</DialogTitle>
                <DialogDescription>
                  Set a new end date for {selectedForManagement?.ptas?.name}'s trial
                </DialogDescription>
              </DialogHeader>
              <div className="space-y-4">
                <div>
                  <Label>Current End Date</Label>
                  <Input 
                    value={selectedForManagement?.trial_ends_at ? new Date(selectedForManagement.trial_ends_at).toLocaleDateString() : 'Not set'} 
                    disabled 
                  />
                </div>
                <div>
                  <Label>New End Date</Label>
                  <Input 
                    type="date" 
                    value={newTrialEndDate} 
                    onChange={(e) => setNewTrialEndDate(e.target.value)} 
                  />
                </div>
                <Button onClick={handleExtendTrial} className="w-full">
                  Extend Trial
                </Button>
              </div>
            </DialogContent>
          </Dialog>

          {/* Convert to Paid Dialog */}
          <Dialog open={convertDialogOpen} onOpenChange={setConvertDialogOpen}>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Convert to Paid Plan</DialogTitle>
                <DialogDescription>
                  Select a plan for {selectedForManagement?.ptas?.name || selectedForManagement?.business_name}
                </DialogDescription>
              </DialogHeader>
              <div className="space-y-4">
                <div>
                  <Label>Plan</Label>
                  <Select value={convertToPlan} onValueChange={setConvertToPlan}>
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="basic">Basic</SelectItem>
                      <SelectItem value="standard">Standard</SelectItem>
                      <SelectItem value="premium">Premium</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <Button 
                  onClick={() => {
                    if (selectedForManagement?.business_name) {
                      handleConvertSponsoredToPaid(selectedForManagement);
                    } else {
                      handleConvertToPaid();
                    }
                  }} 
                  className="w-full"
                >
                  Convert to {convertToPlan}
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </TabsContent>

        {/* Shop Tab */}
        <TabsContent value="shop" className="space-y-4">
          <div className="flex justify-between items-center mb-4">
            <div className="flex gap-4 items-center">
              <p className="text-sm text-muted-foreground">Total Items: {shopItems.length}</p>
              <Select value={shopCategoryFilter} onValueChange={setShopCategoryFilter}>
                <SelectTrigger className="w-48">
                  <SelectValue placeholder="Filter by category" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Categories</SelectItem>
                  <SelectItem value="events">Events</SelectItem>
                  <SelectItem value="equipment">Equipment</SelectItem>
                  <SelectItem value="catering">Catering</SelectItem>
                  <SelectItem value="activities">Activities</SelectItem>
                  <SelectItem value="finance">Finance</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setShowAffiliateSettings(true)}
            >
              <SettingsIcon className="h-4 w-4 mr-2" />
              Amazon Settings
            </Button>
          </div>
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold">Shop Items</h2>
            <Dialog open={shopDialogOpen} onOpenChange={setShopDialogOpen}>
              <DialogTrigger asChild>
                <Button><Plus className="h-4 w-4 mr-2" />Add Shop Item</Button>
              </DialogTrigger>
              <DialogContent className="max-w-md">
                <DialogHeader>
                  <DialogTitle>Add Shop Item</DialogTitle>
                </DialogHeader>
                <form onSubmit={handleAddShopItem} className="space-y-4">
                  <div>
                    <Label>Name</Label>
                    <Input name="name" required />
                  </div>
                  <div>
                    <Label>Description</Label>
                    <Textarea name="description" rows={3} />
                  </div>
                  <div>
                    <Label>Category</Label>
                    <Select name="category" required>
                      <SelectTrigger>
                        <SelectValue placeholder="Select category" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="Events">Events</SelectItem>
                        <SelectItem value="Catering">Catering</SelectItem>
                        <SelectItem value="Equipment">Equipment</SelectItem>
                        <SelectItem value="Activities">Activities</SelectItem>
                        <SelectItem value="Finance">Finance</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Amazon Item URL</Label>
                    <Input name="amazon_url" type="url" required placeholder="https://www.amazon.co.uk/..." />
                    <p className="text-xs text-muted-foreground mt-1">
                      Paste the full Amazon product URL
                    </p>
                  </div>
                  <div>
                    <Label>Image URL</Label>
                    <Input name="image" type="url" placeholder="Optional product image URL" />
                  </div>
                  <Button type="submit" className="w-full">Add Item</Button>
                </form>
              </DialogContent>
            </Dialog>
          </div>

          {/* Amazon Affiliate Settings Dialog */}
          <Dialog open={showAffiliateSettings} onOpenChange={setShowAffiliateSettings}>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Amazon Affiliate Settings</DialogTitle>
                <DialogDescription>
                  Configure your Amazon Associate tag to earn commissions
                </DialogDescription>
              </DialogHeader>
              <div className="space-y-4">
                <div>
                  <Label>Amazon Associate Tag</Label>
                  <Input
                    value={amazonAffiliateTag}
                    onChange={(e) => setAmazonAffiliateTag(e.target.value)}
                    placeholder="your-tag-20"
                  />
                  <p className="text-xs text-muted-foreground mt-1">
                    This tag will be automatically added to all new shop items
                  </p>
                </div>
                <Button onClick={() => {
                  toast({ title: "Settings saved", description: "Amazon affiliate tag has been updated" });
                  setShowAffiliateSettings(false);
                }} className="w-full">
                  Save Settings
                </Button>
              </div>
            </DialogContent>
          </Dialog>
          <div className="grid md:grid-cols-3 gap-4">
            {shopItems
              .filter(item => shopCategoryFilter === 'all' || item.category.toLowerCase() === shopCategoryFilter)
              .map((item) => (
              <Card key={item.id} className={item.status === 'inactive' ? 'opacity-50' : ''}>
                <CardHeader>
                  <div className="flex items-start gap-3">
                    {item.image_url && (
                      <img 
                        src={item.image_url} 
                        alt={item.name}
                        className="w-16 h-16 object-cover rounded"
                      />
                    )}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-start justify-between gap-2">
                        <div className="flex-1 min-w-0">
                          <CardTitle className="text-base truncate">{item.name}</CardTitle>
                          <CardDescription>£{item.price}</CardDescription>
                          <Badge variant="outline" className="mt-1">{item.category}</Badge>
                        </div>
                        <div className="flex gap-1 flex-shrink-0">
                          <Button 
                            size="sm" 
                            variant="ghost" 
                            onClick={() => {
                              setSelectedShopItem(item);
                              setEditShopDialogOpen(true);
                            }}
                          >
                            <Edit className="h-4 w-4" />
                          </Button>
                          <Button size="sm" variant="ghost" onClick={() => handleDeleteShopItem(item.id)}>
                            <Trash2 className="h-4 w-4 text-foreground" />
                          </Button>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 mt-2">
                        <Label htmlFor={`status-${item.id}`} className="text-xs">Active</Label>
                        <Switch
                          id={`status-${item.id}`}
                          checked={item.status === 'active'}
                          onCheckedChange={() => handleToggleShopItemStatus(item.id, item.status)}
                        />
                      </div>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            ))}
          </div>
        </TabsContent>

        {/* Tickets Tab */}
        <TabsContent value="tickets" className="space-y-4">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">Support Tickets</h2>
            <Badge variant="secondary">{tickets.length} Total</Badge>
          </div>
          
          {tickets.length === 0 ? (
            <Card>
              <CardContent className="pt-6 text-center text-muted-foreground">
                No support tickets yet
              </CardContent>
            </Card>
          ) : (
            <div className="space-y-3">
              {tickets.map((ticket) => (
                <Card key={ticket.id} className="hover:shadow-md transition-shadow">
                  <CardHeader>
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                          <CardTitle className="text-base">{ticket.subject}</CardTitle>
                          <Badge variant={
                            ticket.status === 'open' ? 'default' : 
                            ticket.status === 'in_progress' ? 'secondary' : 
                            'outline'
                          }>
                            {ticket.status}
                          </Badge>
                          <Badge variant="outline" className="text-xs">
                            {ticket.category}
                          </Badge>
                        </div>
                        <CardDescription className="text-sm mb-2">
                          Ticket #{ticket.id.slice(0, 8)} • Created {new Date(ticket.created_at).toLocaleDateString()}
                        </CardDescription>
                        <p className="text-sm mt-2 text-foreground/80">{ticket.description}</p>
                      </div>
                      <div className="flex gap-2">
                        <Select
                          value={ticket.status}
                          onValueChange={(value) => {
                            supabase
                              .from('support_tickets')
                              .update({ status: value })
                              .eq('id', ticket.id)
                              .then(() => {
                                fetchTickets();
                                toast({
                                  title: "Status Updated",
                                  description: `Ticket status changed to ${value}`,
                                });
                              });
                          }}
                        >
                          <SelectTrigger className="w-32 h-8">
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="open">Open</SelectItem>
                            <SelectItem value="in_progress">In Progress</SelectItem>
                            <SelectItem value="closed">Closed</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>
                  </CardHeader>
                </Card>
              ))}
            </div>
          )}
        </TabsContent>

        {/* Blog Tab */}
        <TabsContent value="blog" className="space-y-4">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold">Blog Posts</h2>
            <Dialog open={blogDialogOpen} onOpenChange={(open) => {
              setBlogDialogOpen(open);
              if (!open) resetBlogForm();
            }}>
              <DialogTrigger asChild>
                <Button><Plus className="h-4 w-4 mr-2" />Add Blog Post</Button>
              </DialogTrigger>
              <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                  <DialogTitle>Add Blog Post</DialogTitle>
                </DialogHeader>
                
                {/* Auto Blog Button */}
                <div className="mb-4">
                  <Button 
                    type="button" 
                    variant="outline" 
                    onClick={handleGetBlogIdeas}
                    disabled={isLoadingIdeas}
                    className="w-full"
                  >
                    {isLoadingIdeas ? (
                      <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    ) : (
                      <Wand2 className="h-4 w-4 mr-2" />
                    )}
                    {isLoadingIdeas ? 'Generating Ideas...' : 'Auto Blog - Get AI Ideas'}
                  </Button>
                </div>
                
                {/* Blog Ideas Panel */}
                {showBlogIdeas && (
                  <div className="border rounded-lg p-4 mb-4 bg-muted/30">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="font-semibold flex items-center gap-2">
                        <Sparkles className="h-4 w-4 text-primary" />
                        Blog Ideas
                      </h3>
                      <Button 
                        type="button" 
                        variant="ghost" 
                        size="sm"
                        onClick={handleRefreshAllIdeas}
                        disabled={isLoadingIdeas}
                      >
                        <RefreshCw className={`h-4 w-4 mr-1 ${isLoadingIdeas ? 'animate-spin' : ''}`} />
                        Refresh All
                      </Button>
                    </div>
                    
                    {isLoadingIdeas && blogIdeas.length === 0 ? (
                      <div className="flex items-center justify-center py-8">
                        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
                        <span className="ml-2 text-muted-foreground">Generating ideas...</span>
                      </div>
                    ) : (
                      <div className="space-y-2 max-h-64 overflow-y-auto">
                        {blogIdeas.map((idea, index) => (
                          <div 
                            key={idea.id || index}
                            className={`flex items-center justify-between p-3 rounded-lg border transition-colors ${
                              generatingIdeaIndex === index 
                                ? 'bg-primary/10 border-primary' 
                                : 'bg-background hover:bg-accent cursor-pointer'
                            }`}
                            onClick={() => !isGeneratingPost && handleSelectIdea(index)}
                          >
                            <span className="flex-1 text-sm">{idea.title}</span>
                            <div className="flex items-center gap-1 ml-2">
                              {generatingIdeaIndex === index ? (
                                <Loader2 className="h-4 w-4 animate-spin text-primary" />
                              ) : (
                                <>
                                  <Button
                                    type="button"
                                    variant="ghost"
                                    size="icon"
                                    className="h-7 w-7"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleRefreshIdea(index);
                                    }}
                                    disabled={isGeneratingPost}
                                  >
                                    <RefreshCw className="h-3 w-3" />
                                  </Button>
                                  <Button
                                    type="button"
                                    variant="ghost"
                                    size="sm"
                                    className="text-xs"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSelectIdea(index);
                                    }}
                                    disabled={isGeneratingPost}
                                  >
                                    Use
                                  </Button>
                                </>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                
                <form onSubmit={handleAddBlogPost} className="space-y-4">
                  <div>
                    <Label>Title</Label>
                    <Input 
                      name="title" 
                      required 
                      value={blogFormData.title}
                      onChange={(e) => setBlogFormData(prev => ({ ...prev, title: e.target.value }))}
                    />
                  </div>
                  <div>
                    <Label>Author Name</Label>
                    <Input 
                      name="author_name" 
                      placeholder="e.g., John Smith" 
                      value={blogFormData.author_name}
                      onChange={(e) => setBlogFormData(prev => ({ ...prev, author_name: e.target.value }))}
                    />
                  </div>
                  <div>
                    <Label>Tags (comma separated)</Label>
                    <Input 
                      name="tags" 
                      placeholder="e.g., Tips, Fundraising, Events" 
                      value={blogFormData.tags}
                      onChange={(e) => setBlogFormData(prev => ({ ...prev, tags: e.target.value }))}
                    />
                  </div>
                  <div>
                    <Label>Excerpt</Label>
                    <Textarea 
                      name="excerpt" 
                      rows={2} 
                      required 
                      value={blogFormData.excerpt}
                      onChange={(e) => setBlogFormData(prev => ({ ...prev, excerpt: e.target.value }))}
                    />
                  </div>
                  <div>
                    <Label>Content</Label>
                    <Textarea 
                      name="content" 
                      rows={8} 
                      required 
                      value={blogFormData.content}
                      onChange={(e) => setBlogFormData(prev => ({ ...prev, content: e.target.value }))}
                    />
                  </div>
                  <div>
                    <Label>Cover Image {isGeneratingCover && <span className="text-primary text-xs ml-2">(Generating with AI...)</span>}</Label>
                    <div 
                      className={`border-2 border-dashed rounded-lg p-6 transition-colors ${
                        isGeneratingCover ? 'border-primary bg-primary/5 animate-pulse' :
                        blogImageFile ? 'border-primary bg-primary/5' : 'border-border hover:border-primary/50'
                      }`}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.currentTarget.classList.add('border-primary', 'bg-primary/5');
                      }}
                      onDragLeave={(e) => {
                        e.currentTarget.classList.remove('border-primary', 'bg-primary/5');
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.currentTarget.classList.remove('border-primary', 'bg-primary/5');
                        const files = e.dataTransfer.files;
                        if (files.length > 0 && files[0].type.startsWith('image/')) {
                          setBlogImageFile(files[0]);
                        }
                      }}
                    >
                      <div className="text-center">
                        {isGeneratingCover ? (
                          <>
                            <Loader2 className="h-8 w-8 mx-auto mb-2 text-primary animate-spin" />
                            <p className="text-sm text-muted-foreground mb-2">
                              AI is generating a cover image...
                            </p>
                          </>
                        ) : (
                          <>
                            <Upload className="h-8 w-8 mx-auto mb-2 text-muted-foreground" />
                            <p className="text-sm text-muted-foreground mb-2">
                              {blogImageFile ? blogImageFile.name : 'Drag and drop an image, or click to browse'}
                            </p>
                            <Input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const files = e.target.files;
                                if (files && files.length > 0) {
                                  setBlogImageFile(files[0]);
                                }
                              }}
                              className="cursor-pointer"
                            />
                            {blogImageFile && (
                              <Button
                                type="button"
                                variant="ghost"
                                size="sm"
                                className="mt-2"
                                onClick={() => setBlogImageFile(null)}
                              >
                                <X className="h-4 w-4 mr-1" />
                                Remove
                              </Button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <Button type="submit" className="w-full" disabled={isGeneratingCover}>
                    {isGeneratingCover ? 'Wait for cover...' : 'Publish'}
                  </Button>
                </form>
              </DialogContent>
            </Dialog>
          </div>
          <div className="space-y-3">
            {blogPosts.map((post) => (
              <Card key={post.id}>
                <CardHeader>
                  <div className="flex items-start justify-between">
                    <div>
                      <CardTitle className="text-base">{post.title}</CardTitle>
                      <CardDescription>{post.excerpt}</CardDescription>
                    </div>
                    <div className="flex gap-1">
                      <Button 
                        size="sm" 
                        variant="ghost"
                        onClick={() => {
                          setPreviewBlogPost(post);
                          setPreviewBlogDialogOpen(true);
                        }}
                      >
                        <Eye className="h-4 w-4" />
                      </Button>
                      <Button 
                        size="sm" 
                        variant="ghost"
                        onClick={() => {
                          setSelectedBlogPost(post);
                          setEditBlogDialogOpen(true);
                        }}
                      >
                        <Edit className="h-4 w-4" />
                      </Button>
                      <Button size="sm" variant="ghost" onClick={() => handleDeleteBlogPost(post.id)}><Trash2 className="h-4 w-4 text-foreground" /></Button>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            ))}
          </div>

          {/* Blog Preview Dialog */}
          <Dialog open={previewBlogDialogOpen} onOpenChange={setPreviewBlogDialogOpen}>
            <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle>Blog Post Preview</DialogTitle>
              </DialogHeader>
              {previewBlogPost && (
                <div className="space-y-4">
                  {previewBlogPost.image_url && (
                    <img 
                      src={previewBlogPost.image_url} 
                      alt={previewBlogPost.title}
                      className="w-full h-48 object-cover rounded-lg"
                    />
                  )}
                  <div>
                    <h2 className="text-2xl font-bold">{previewBlogPost.title}</h2>
                    <div className="flex items-center gap-2 mt-2 text-sm text-muted-foreground">
                      {previewBlogPost.author_name && (
                        <span>By {previewBlogPost.author_name}</span>
                      )}
                      {previewBlogPost.published_at && (
                        <>
                          <span>•</span>
                          <span>{new Date(previewBlogPost.published_at).toLocaleDateString()}</span>
                        </>
                      )}
                    </div>
                  </div>
                  {previewBlogPost.tags && previewBlogPost.tags.length > 0 && (
                    <div className="flex flex-wrap gap-2">
                      {previewBlogPost.tags.map((tag: string, i: number) => (
                        <Badge key={i} variant="secondary">{tag}</Badge>
                      ))}
                    </div>
                  )}
                  {previewBlogPost.excerpt && (
                    <p className="text-muted-foreground italic border-l-4 border-primary pl-4">
                      {previewBlogPost.excerpt}
                    </p>
                  )}
                  <div className="prose prose-sm dark:prose-invert max-w-none">
                    <div 
                      dangerouslySetInnerHTML={{ 
                        __html: previewBlogPost.content
                          ?.replace(/\n/g, '<br/>')
                          ?.replace(/## (.*?)(?=<br\/>|$)/g, '<h2 class="text-lg font-semibold mt-4 mb-2">$1</h2>')
                          ?.replace(/### (.*?)(?=<br\/>|$)/g, '<h3 class="text-base font-semibold mt-3 mb-1">$1</h3>')
                          || ''
                      }} 
                    />
                  </div>
                </div>
              )}
            </DialogContent>
          </Dialog>
        </TabsContent>

        {/* Changelog Tab */}
        <TabsContent value="changelog" className="space-y-4">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold">Changelog Entries</h2>
            <Dialog open={changelogDialogOpen} onOpenChange={setChangelogDialogOpen}>
              <DialogTrigger asChild>
                <Button><Plus className="h-4 w-4 mr-2" />Add Entry</Button>
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Add Changelog Entry</DialogTitle>
                </DialogHeader>
                <form onSubmit={handleAddChangelog} className="space-y-4">
                  <div><Label>Title</Label><Input name="title" required /></div>
                  <div><Label>Description</Label><Textarea name="description" rows={4} required /></div>
                  <div>
                    <Label>Type</Label>
                    <Select name="type" required>
                      <SelectTrigger>
                        <SelectValue placeholder="Select type" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="feature">Feature</SelectItem>
                        <SelectItem value="improvement">Improvement</SelectItem>
                        <SelectItem value="bugfix">Bug Fix</SelectItem>
                        <SelectItem value="breaking">Breaking Change</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <Button type="submit" className="w-full">Add Entry</Button>
                </form>
              </DialogContent>
            </Dialog>
          </div>
          <div className="space-y-3">
            {changelog.map((entry: any) => (
              <Card key={entry.id}>
                <CardHeader>
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 flex-wrap">
                        <CardTitle className="text-base">{entry.title}</CardTitle>
                        {getChangeTypeBadge(entry.change_type)}
                        <Badge variant="outline" className="text-xs">
                          {new Date(entry.published_at).toLocaleDateString('en-GB', { 
                            day: 'numeric', 
                            month: 'short', 
                            year: 'numeric' 
                          })}
                        </Badge>
                      </div>
                      <CardDescription className="mt-1">{entry.description}</CardDescription>
                    </div>
                    <div className="flex gap-1">
                      <Button size="sm" variant="ghost" onClick={() => { setSelectedChangelog(entry); setEditChangelogDialogOpen(true); }}><Edit className="h-4 w-4 text-foreground" /></Button>
                      <Button size="sm" variant="ghost" onClick={() => handleDeleteChangelog(entry.id)}><Trash2 className="h-4 w-4 text-foreground" /></Button>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            ))}
          </div>

          {/* Edit Changelog Dialog */}
          <Dialog open={editChangelogDialogOpen} onOpenChange={setEditChangelogDialogOpen}>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Edit Changelog Entry</DialogTitle>
              </DialogHeader>
              <form onSubmit={handleUpdateChangelog} className="space-y-4">
                <div><Label>Title</Label><Input name="title" defaultValue={selectedChangelog?.title} required /></div>
                <div><Label>Description</Label><Textarea name="description" defaultValue={selectedChangelog?.description} rows={4} required /></div>
                <div>
                  <Label>Type</Label>
                  <Select name="type" defaultValue={selectedChangelog?.change_type} required>
                    <SelectTrigger>
                      <SelectValue placeholder="Select type" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="feature">Feature</SelectItem>
                      <SelectItem value="improvement">Improvement</SelectItem>
                      <SelectItem value="bugfix">Bug Fix</SelectItem>
                      <SelectItem value="breaking">Breaking Change</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <Button type="submit" className="w-full">Save Changes</Button>
              </form>
            </DialogContent>
          </Dialog>
        </TabsContent>

        {/* Pricing Tab */}
        <TabsContent value="pricing" className="space-y-6">
          <Card>
            <CardHeader>
              <div className="flex justify-between items-center">
                <div>
                  <CardTitle>Pricing Plans</CardTitle>
                  <CardDescription>Manage the pricing plans displayed on the pricing page</CardDescription>
                </div>
                <Dialog>
                  <DialogTrigger asChild>
                    <Button>
                      <Plus className="h-4 w-4 mr-2" />
                      Create New Plan
                    </Button>
                  </DialogTrigger>
                  <DialogContent>
                    <DialogHeader>
                      <DialogTitle>Create New Pricing Plan</DialogTitle>
                    </DialogHeader>
                    <form onSubmit={async (e) => {
                      e.preventDefault();
                      const formData = new FormData(e.currentTarget);
                      
                      // Get the highest current display_order
                      const { data: existingPlans } = await supabase
                        .from('pricing_plans')
                        .select('display_order')
                        .order('display_order', { ascending: false })
                        .limit(1);
                      
                      const nextOrder = existingPlans && existingPlans.length > 0 
                        ? (existingPlans[0].display_order || 0) + 1 
                        : 0;
                      
                      const { error } = await supabase.from('pricing_plans').insert({
                        name: formData.get('name') as string,
                        price: parseFloat(formData.get('price') as string),
                        description: formData.get('description') as string,
                        is_popular: false,
                        display_order: nextOrder,
                      });
                      if (error) {
                        toast({ title: "Error", description: error.message, variant: "destructive" });
                      } else {
                        toast({ title: "Success", description: "Pricing plan created successfully" });
                        fetchPricingPlans();
                        e.currentTarget.reset();
                      }
                    }} className="space-y-4">
                      <div>
                        <Label htmlFor="name">Plan Name</Label>
                        <Input id="name" name="name" placeholder="e.g., Premium" required />
                      </div>
                      <div>
                        <Label htmlFor="price">Price (£/year)</Label>
                        <Input id="price" name="price" type="number" step="0.01" placeholder="199.99" required />
                      </div>
                      <div>
                        <Label htmlFor="description">Description</Label>
                        <Textarea id="description" name="description" placeholder="Brief description of the plan" required />
                      </div>
                      <Button type="submit" className="w-full">Create Plan</Button>
                    </form>
                  </DialogContent>
                </Dialog>
              </div>
            </CardHeader>
            <CardContent>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {pricingPlans.map((plan, index) => (
                  <Card key={plan.id} className={plan.is_popular ? "border-2 border-primary" : ""}>
                    <CardHeader>
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-1">
                            <CardTitle className="text-xl">{plan.name}</CardTitle>
                            <Badge variant="outline" className="text-xs">Order: {plan.display_order}</Badge>
                          </div>
                          <CardDescription>{plan.description}</CardDescription>
                        </div>
                        <div className="flex gap-1">
                          <Button
                            variant="outline"
                            size="icon"
                            onClick={() => {
                              setSelectedPlan(plan);
                              setSelectedPlanFeatures(planFeatures[plan.id] || []);
                              setEditPlanDialogOpen(true);
                            }}
                          >
                            <Edit className="h-4 w-4" />
                          </Button>
                          <Button
                            variant="outline"
                            size="icon"
                            title="Duplicate plan"
                            onClick={async () => {
                              try {
                                const { data: newPlanId, error: rpcErr } = await supabase
                                  .rpc('duplicate_pricing_plan', { p_plan_id: plan.id });
                                if (rpcErr) throw rpcErr;
                                if (!newPlanId) throw new Error('Failed to duplicate plan — you may not have permission.');
                                toast({ title: "Success", description: "Plan duplicated successfully" });
                                await fetchPricingPlans();
                                // Open the new copy in the edit dialog — re-fetch needed so use fresh data
                                const { data: freshPlans } = await supabase.from('pricing_plans').select('*').eq('id', newPlanId).single();
                                if (freshPlans) {
                                  const { data: freshFeatures } = await supabase.from('plan_features').select('*').eq('plan_id', newPlanId).order('feature_order', { ascending: true });
                                  setSelectedPlan(freshPlans);
                                  setSelectedPlanFeatures(freshFeatures || []);
                                  setEditPlanDialogOpen(true);
                                }
                              } catch (err: any) {
                                toast({ title: "Error", description: err.message, variant: "destructive" });
                              }
                            }}
                          >
                            <Copy className="h-4 w-4" />
                          </Button>
                          <Button
                            variant="outline"
                            size="icon"
                            onClick={async () => {
                              if (confirm(`Are you sure you want to delete the ${plan.name} plan?`)) {
                                const { error } = await supabase
                                  .from('pricing_plans')
                                  .delete()
                                  .eq('id', plan.id);
                                if (error) {
                                  toast({ title: "Error", description: error.message, variant: "destructive" });
                                } else {
                                  toast({ title: "Success", description: "Plan deleted successfully" });
                                  fetchPricingPlans();
                                }
                              }
                            }}
                          >
                            <Trash2 className="h-4 w-4 text-foreground" />
                          </Button>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <div className="text-3xl font-bold text-primary mb-4">
                        £{plan.price.toFixed(2)}<span className="text-sm text-muted-foreground">/year</span>
                      </div>
                      <div className="flex gap-2 mb-4">
                        <Button
                          variant="outline"
                          size="sm"
                          disabled={index === 0}
                          onClick={async () => {
                            const prevPlan = pricingPlans[index - 1];
                            if (!prevPlan) return;
                            await supabase.from('pricing_plans').update({ display_order: prevPlan.display_order }).eq('id', plan.id);
                            await supabase.from('pricing_plans').update({ display_order: plan.display_order }).eq('id', prevPlan.id);
                            await fetchPricingPlans();
                            toast({ title: "Success", description: "Plan order updated" });
                          }}
                        >
                          Move Left
                        </Button>
                        <Button
                          variant="outline"
                          size="sm"
                          disabled={index === pricingPlans.length - 1}
                          onClick={async () => {
                            const nextPlan = pricingPlans[index + 1];
                            if (!nextPlan) return;
                            await supabase.from('pricing_plans').update({ display_order: nextPlan.display_order }).eq('id', plan.id);
                            await supabase.from('pricing_plans').update({ display_order: plan.display_order }).eq('id', nextPlan.id);
                            await fetchPricingPlans();
                            toast({ title: "Success", description: "Plan order updated" });
                          }}
                        >
                          Move Right
                        </Button>
                      </div>
                      <div className="space-y-2">
                        <p className="font-semibold text-sm">Features ({planFeatures[plan.id]?.length || 0}):</p>
                        <ul className="space-y-1 text-sm text-muted-foreground">
                          {(planFeatures[plan.id] || []).slice(0, 5).map((feature) => (
                            <li key={feature.id} className="flex items-center gap-2">
                              <Check className="h-3 w-3 text-primary" />
                              {feature.feature_name}
                            </li>
                          ))}
                          {(planFeatures[plan.id]?.length || 0) > 5 && (
                            <li className="text-xs italic">
                              +{(planFeatures[plan.id]?.length || 0) - 5} more features
                            </li>
                          )}
                        </ul>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className="flex justify-between items-center">
                <div>
                  <CardTitle>Add-ons</CardTitle>
                  <CardDescription>Manage available add-ons for the Basic plan</CardDescription>
                </div>
                <Button
                  onClick={() => {
                    setSelectedAddon(null);
                    setEditAddonDialogOpen(true);
                  }}
                >
                  <Plus className="h-4 w-4 mr-2" />
                  Add New Add-on
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                {addons.map((addon) => (
                  <div key={addon.id} className="flex items-center justify-between p-4 border rounded-lg">
                    <div>
                      <p className="font-medium">{addon.name}</p>
                      {addon.description && (
                        <p className="text-sm text-muted-foreground">{addon.description}</p>
                      )}
                    </div>
                    <div className="flex items-center gap-4">
                      <span className="text-lg font-bold text-primary">
                        £{addon.price.toFixed(2)}<span className="text-sm text-muted-foreground">/yr</span>
                      </span>
                      <div className="flex gap-2">
                        <Button
                          variant="outline"
                          size="icon"
                          onClick={() => {
                            setSelectedAddon(addon);
                            setEditAddonDialogOpen(true);
                          }}
                        >
                          <Edit className="h-4 w-4" />
                        </Button>
                        <Button
                          variant="outline"
                          size="icon"
                          onClick={async () => {
                            if (window.confirm(`Delete ${addon.name}?`)) {
                              await supabase.from('pricing_addons').delete().eq('id', addon.id);
                              fetchAddons();
                              toast({ title: "Add-on deleted successfully" });
                            }
                          }}
                        >
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Policies Tab */}
        <TabsContent value="policies" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>Site Policies</CardTitle>
              <CardDescription>Manage the text for site policies (Terms, Privacy, etc.)</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {policies.map((policy) => (
                  <Card key={policy.id}>
                    <CardHeader>
                      <div className="flex justify-between items-center">
                        <div>
                          <CardTitle className="text-lg">{policy.title}</CardTitle>
                          <CardDescription className="capitalize">{policy.policy_type.replace('_', ' ')}</CardDescription>
                        </div>
                        <Button
                          variant="outline"
                          onClick={() => {
                            setSelectedPolicy(policy);
                            setEditPolicyDialogOpen(true);
                          }}
                        >
                          <Edit className="h-4 w-4 mr-2" />
                          Edit Content
                        </Button>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <div className="bg-muted p-4 rounded-lg max-h-32 overflow-y-auto">
                        <p className="text-sm text-muted-foreground line-clamp-4">
                          {policy.content.substring(0, 200)}...
                        </p>
                      </div>
                      <p className="text-xs text-muted-foreground mt-2">
                        Last updated: {new Date(policy.updated_at).toLocaleDateString()}
                      </p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Roadmap Tab */}
        <TabsContent value="roadmap" className="space-y-4">
          <RoadmapManagement />
        </TabsContent>

        {/* Referrals Tab */}
        <TabsContent value="referrals" className="space-y-4">
          <SiteAdminReferralsTab />
        </TabsContent>

        {/* Notices Tab */}
        <TabsContent value="notices" className="space-y-4">
          <Card>
            <CardHeader>
              <div className="flex justify-between items-center">
                <div>
                  <CardTitle>Site Notices</CardTitle>
                  <CardDescription>Create temporary banners shown on PTA Admin or Member dashboards</CardDescription>
                </div>
                <Button onClick={() => openNoticeDialog()}>
                  <Plus className="h-4 w-4 mr-2" /> Add Notice
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              {notices.length === 0 ? (
                <p className="text-muted-foreground text-center py-8">No notices yet</p>
              ) : (
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Title</TableHead>
                      <TableHead>Status</TableHead>
                      <TableHead>Target</TableHead>
                      <TableHead>Schedule</TableHead>
                      <TableHead className="text-right">Actions</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {notices.map((notice) => (
                      <TableRow key={notice.id}>
                        <TableCell className="font-medium">{notice.title || notice.message.slice(0, 40)}</TableCell>
                        <TableCell>
                          <Badge variant={notice.is_enabled ? "default" : "secondary"}>
                            {notice.is_enabled ? "Enabled" : "Disabled"}
                          </Badge>
                        </TableCell>
                        <TableCell>
                          <div className="flex gap-1 flex-wrap">
                            {notice.show_on_pta_admin && <Badge variant="outline">PTA Admin</Badge>}
                            {notice.show_on_member_dashboard && <Badge variant="outline">Member</Badge>}
                          </div>
                        </TableCell>
                        <TableCell className="text-sm text-muted-foreground">
                          {notice.starts_at ? new Date(notice.starts_at).toLocaleDateString() : "—"}
                          {" → "}
                          {notice.ends_at ? new Date(notice.ends_at).toLocaleDateString() : "—"}
                        </TableCell>
                        <TableCell className="text-right">
                          <div className="flex gap-1 justify-end">
                            <Button variant="outline" size="icon" onClick={() => openNoticeDialog(notice)}>
                              <Edit className="h-4 w-4" />
                            </Button>
                            <Button variant="outline" size="icon" onClick={() => handleDeleteNotice(notice.id)}>
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>

          {/* Notice Dialog */}
          <Dialog open={noticeDialogOpen} onOpenChange={setNoticeDialogOpen}>
            <DialogContent className="max-w-lg">
              <DialogHeader>
                <DialogTitle>{editingNotice ? "Edit Notice" : "Add Notice"}</DialogTitle>
              </DialogHeader>
              <div className="space-y-4">
                <div>
                  <Label>Title</Label>
                  <Input value={noticeForm.title} onChange={(e) => setNoticeForm(f => ({ ...f, title: e.target.value }))} placeholder="Optional title" />
                </div>
                <div>
                  <Label>Message *</Label>
                  <Textarea value={noticeForm.message} onChange={(e) => setNoticeForm(f => ({ ...f, message: e.target.value }))} placeholder="What users need to know..." rows={3} />
                </div>
                <div>
                  <Label>Background Colour</Label>
                  <div className="flex items-center gap-2 mt-1">
                    <input type="color" value={noticeForm.bg_color} onChange={(e) => setNoticeForm(f => ({ ...f, bg_color: e.target.value }))} className="w-10 h-10 rounded border cursor-pointer" />
                    <Input value={noticeForm.bg_color} onChange={(e) => setNoticeForm(f => ({ ...f, bg_color: e.target.value }))} className="w-32" />
                  </div>
                </div>
                <div className="flex items-center justify-between rounded-lg border p-3">
                  <Label className="cursor-pointer">Enabled</Label>
                  <Switch checked={noticeForm.is_enabled} onCheckedChange={(v) => setNoticeForm(f => ({ ...f, is_enabled: v }))} />
                </div>
                <div className="flex items-center justify-between rounded-lg border p-3">
                  <Label className="cursor-pointer">Show on PTA Admin Dashboard</Label>
                  <Switch checked={noticeForm.show_on_pta_admin} onCheckedChange={(v) => setNoticeForm(f => ({ ...f, show_on_pta_admin: v }))} />
                </div>
                <div className="flex items-center justify-between rounded-lg border p-3">
                  <Label className="cursor-pointer">Show on Member Dashboard</Label>
                  <Switch checked={noticeForm.show_on_member_dashboard} onCheckedChange={(v) => setNoticeForm(f => ({ ...f, show_on_member_dashboard: v }))} />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Start Date & Time</Label>
                    <Input type="datetime-local" value={noticeForm.starts_at} onChange={(e) => setNoticeForm(f => ({ ...f, starts_at: e.target.value }))} />
                  </div>
                  <div>
                    <Label>End Date & Time</Label>
                    <Input type="datetime-local" value={noticeForm.ends_at} onChange={(e) => setNoticeForm(f => ({ ...f, ends_at: e.target.value }))} />
                  </div>
                </div>
                <p className="text-xs text-muted-foreground">Leave dates empty for an always-active notice (when enabled).</p>
                <div className="flex justify-end gap-2">
                  <Button variant="outline" onClick={() => setNoticeDialogOpen(false)}>Cancel</Button>
                  <Button onClick={handleSaveNotice}>{editingNotice ? "Save Changes" : "Create Notice"}</Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </TabsContent>

        {/* Admins Tab */}
        <TabsContent value="admins" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>Site Administrators</CardTitle>
              <CardDescription>Manage site admin access and permissions</CardDescription>
            </CardHeader>
            <CardContent>
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Email</TableHead>
                    <TableHead>Full Name</TableHead>
                    <TableHead>Added</TableHead>
                    <TableHead>Allowed Tabs</TableHead>
                    <TableHead className="text-right">Actions</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {siteAdmins.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={5} className="text-center text-muted-foreground">
                        No site admins found
                      </TableCell>
                    </TableRow>
                  ) : (
                    siteAdmins.map((admin) => {
                      const isPrimaryAdmin = admin.email === 'info@ptahub.co.uk';
                      const permissions = siteAdminPermissions.find(p => p.user_id === admin.id);
                      const allowedTabs = permissions?.allowed_tabs || [];
                      const allTabs = ['summary', 'library', 'users', 'subscriptions', 'shop', 'tickets', 'blog', 'changelog', 'pricing', 'features', 'forum', 'emails', 'seo', 'payments', 'settings', 'policies', 'admins'];
                      
                      return (
                        <TableRow key={admin.id}>
                          <TableCell className="font-medium">
                            <div className="flex items-center gap-2">
                              {admin.email}
                              {isPrimaryAdmin && (
                                <Badge variant="default" className="text-xs">Primary Admin</Badge>
                              )}
                            </div>
                          </TableCell>
                          <TableCell>{admin.full_name || '-'}</TableCell>
                          <TableCell>{new Date(admin.created_at).toLocaleDateString()}</TableCell>
                          <TableCell>
                            {isPrimaryAdmin ? (
                              <Badge variant="secondary">All Tabs</Badge>
                            ) : allowedTabs.length === 0 ? (
                              <span className="text-muted-foreground text-sm">All tabs (default)</span>
                            ) : allowedTabs.length === allTabs.length ? (
                              <Badge variant="secondary">All Tabs</Badge>
                            ) : (
                              <div className="flex flex-wrap gap-1">
                                {allowedTabs.slice(0, 3).map((tab: string) => (
                                  <Badge key={tab} variant="outline" className="text-xs capitalize">{tab}</Badge>
                                ))}
                                {allowedTabs.length > 3 && (
                                  <Badge variant="outline" className="text-xs">+{allowedTabs.length - 3} more</Badge>
                                )}
                              </div>
                            )}
                          </TableCell>
                          <TableCell className="text-right">
                            {!isPrimaryAdmin && (
                              <div className="flex justify-end gap-2">
                                <Button 
                                  size="sm" 
                                  variant="ghost"
                                  onClick={() => {
                                    setSelectedAdmin(admin);
                                    setSelectedAdminTabs(permissions?.allowed_tabs || allTabs);
                                    setEditAdminDialogOpen(true);
                                  }}
                                >
                                  <Edit className="h-4 w-4" />
                                </Button>
                              </div>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
              
              <div className="mt-4 p-4 bg-muted rounded-lg">
                <p className="text-sm text-muted-foreground">
                  <strong>Note:</strong> To add new site administrators, add them from the backend and assign them the 'site_admin' role. 
                  They will then appear here where you can configure their tab access permissions.
                </p>
              </div>
            </CardContent>
          </Card>
          
          {/* Edit Admin Permissions Dialog */}
          <Dialog open={editAdminDialogOpen} onOpenChange={setEditAdminDialogOpen}>
            <DialogContent className="max-w-md">
              <DialogHeader>
                <DialogTitle>Edit Admin Permissions</DialogTitle>
                <DialogDescription>
                  Select which tabs {selectedAdmin?.email} can access
                </DialogDescription>
              </DialogHeader>
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-2 max-h-64 overflow-y-auto">
                  {['summary', 'library', 'users', 'subscriptions', 'shop', 'tickets', 'blog', 'changelog', 'pricing', 'features', 'forum', 'emails', 'seo', 'payments', 'settings', 'policies', 'admins'].map((tab) => (
                    <div key={tab} className="flex items-center space-x-2">
                      <Checkbox 
                        id={`tab-${tab}`}
                        checked={selectedAdminTabs.includes(tab)}
                        onCheckedChange={(checked) => {
                          if (checked) {
                            setSelectedAdminTabs([...selectedAdminTabs, tab]);
                          } else {
                            setSelectedAdminTabs(selectedAdminTabs.filter(t => t !== tab));
                          }
                        }}
                      />
                      <label htmlFor={`tab-${tab}`} className="text-sm capitalize cursor-pointer">
                        {tab}
                      </label>
                    </div>
                  ))}
                </div>
                <div className="flex gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setSelectedAdminTabs(['summary', 'library', 'users', 'subscriptions', 'shop', 'tickets', 'blog', 'changelog', 'pricing', 'features', 'forum', 'emails', 'seo', 'payments', 'settings', 'policies', 'admins'])}
                  >
                    Select All
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setSelectedAdminTabs([])}
                  >
                    Clear All
                  </Button>
                </div>
                <Button 
                  onClick={async () => {
                    if (!selectedAdmin) return;
                    
                    const existingPermission = siteAdminPermissions.find(p => p.user_id === selectedAdmin.id);
                    
                    if (existingPermission) {
                      const { error } = await supabase
                        .from('site_admin_permissions')
                        .update({ allowed_tabs: selectedAdminTabs })
                        .eq('id', existingPermission.id);
                      
                      if (error) {
                        toast({ title: "Error", description: error.message, variant: "destructive" });
                        return;
                      }
                    } else {
                      const { error } = await supabase
                        .from('site_admin_permissions')
                        .insert({ user_id: selectedAdmin.id, allowed_tabs: selectedAdminTabs });
                      
                      if (error) {
                        toast({ title: "Error", description: error.message, variant: "destructive" });
                        return;
                      }
                    }
                    
                    toast({ title: "Success", description: "Admin permissions updated" });
                    setEditAdminDialogOpen(false);
                    setSelectedAdmin(null);
                    fetchSiteAdmins();
                  }}
                  className="w-full"
                >
                  Save Permissions
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </TabsContent>

        {/* Features Tab */}
        <TabsContent value="features" className="space-y-4">
          <FeaturesManagement />
        </TabsContent>

        {/* Forum Tab */}
        <TabsContent value="forum" className="space-y-4">
          <Tabs defaultValue="categories" className="w-full">
            <TabsList>
              <TabsTrigger value="categories">Categories</TabsTrigger>
              <TabsTrigger value="threads">Threads & Posts</TabsTrigger>
              <TabsTrigger value="reports">
                Post Reports {forumPostReports.filter(r => r.status === 'pending').length > 0 && 
                  <Badge variant="destructive" className="ml-2">{forumPostReports.filter(r => r.status === 'pending').length}</Badge>}
              </TabsTrigger>
              <TabsTrigger value="feature-requests">Feature Requests ({featureRequests.length})</TabsTrigger>
            </TabsList>

            {/* Categories Tab */}
            <TabsContent value="categories" className="space-y-4">
              <div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold">Forum Categories</h2>
                <Dialog open={categoryDialogOpen} onOpenChange={setCategoryDialogOpen}>
                  <DialogTrigger asChild>
                    <Button><Plus className="h-4 w-4 mr-2" />Add Category</Button>
                  </DialogTrigger>
                  <DialogContent>
                    <DialogHeader>
                      <DialogTitle>Add Forum Category</DialogTitle>
                    </DialogHeader>
                    <form onSubmit={handleAddCategory} className="space-y-4">
                      <div>
                        <Label>Name</Label>
                        <Input name="name" required />
                      </div>
                      <div>
                        <Label>Description</Label>
                        <Textarea name="description" rows={2} />
                      </div>
                      <Button type="submit" className="w-full">Create Category</Button>
                    </form>
                  </DialogContent>
                </Dialog>
              </div>
              <div className="space-y-2">
                {forumCategories.map((category, index) => (
                  <Card key={category.id}>
                    <CardContent className="p-4 flex items-center justify-between">
                      <div className="flex-1">
                        <h3 className="font-semibold">{category.name}</h3>
                        <p className="text-sm text-muted-foreground">{category.description}</p>
                      </div>
                      <div className="flex gap-2">
                        <Button size="sm" variant="ghost" onClick={() => handleMoveCategoryUp(category, index)} disabled={index === 0}>
                          <MoveUp className="h-4 w-4" />
                        </Button>
                        <Button size="sm" variant="ghost" onClick={() => handleMoveCategoryDown(category, index)} disabled={index === forumCategories.length - 1}>
                          <MoveDown className="h-4 w-4" />
                        </Button>
                        <Button size="sm" variant="ghost" onClick={() => {
                          setSelectedCategory(category);
                          setEditCategoryDialogOpen(true);
                        }}>
                          <Edit className="h-4 w-4" />
                        </Button>
                        <Button size="sm" variant="ghost" onClick={() => handleDeleteCategory(category.id)}>
                          <Trash2 className="h-4 w-4 text-foreground" />
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </TabsContent>

            {/* Threads & Posts Tab */}
            <TabsContent value="threads" className="space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <Card>
                  <CardHeader>
                    <CardTitle>Threads ({forumThreads.length})</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-2 max-h-96 overflow-y-auto">
                    {forumThreads.map((thread) => (
                      <div 
                        key={thread.id}
                        className={`p-3 rounded border cursor-pointer hover:bg-accent ${selectedThread?.id === thread.id ? 'bg-accent' : ''}`}
                        onClick={() => {
                          setSelectedThread(thread);
                          fetchForumPostsForThread(thread.id);
                        }}
                      >
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <h4 className="font-medium">{thread.title}</h4>
                            <p className="text-xs text-muted-foreground mt-1">
                              by {thread.profiles?.display_name || thread.profiles?.full_name} • {thread.forum_categories?.name}
                            </p>
                            <div className="flex gap-2 mt-1">
                              {thread.is_pinned && <Badge variant="secondary" className="text-xs">Pinned</Badge>}
                              {thread.is_locked && <Badge variant="secondary" className="text-xs">Locked</Badge>}
                              {thread.is_feature_request && <Badge variant="secondary" className="text-xs">Feature Request</Badge>}
                            </div>
                          </div>
                          <div className="flex gap-1">
                            <Button size="sm" variant="ghost" onClick={(e) => {
                              e.stopPropagation();
                              setSelectedThread(thread);
                              setEditThreadDialogOpen(true);
                            }}>
                              <Edit className="h-3 w-3" />
                            </Button>
                            <Button size="sm" variant="ghost" onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteThread(thread.id);
                            }}>
                              <Trash2 className="h-3 w-3 text-foreground" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </CardContent>
                </Card>

                <Card>
                  <CardHeader>
                    <CardTitle>
                      {selectedThread ? `Posts in "${selectedThread.title}"` : 'Select a thread to view posts'}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-2 max-h-96 overflow-y-auto">
                    {selectedThread ? (
                      forumPosts.length > 0 ? (
                        forumPosts.map((post) => (
                          <div key={post.id} className="p-3 rounded border">
                            <div className="flex items-start justify-between">
                              <div className="flex-1">
                                <h4 className="font-medium">{post.title}</h4>
                                <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{post.content}</p>
                                <p className="text-xs text-muted-foreground mt-1">
                                  by {post.profiles?.display_name || post.profiles?.full_name}
                                </p>
                                {post.is_hidden && <Badge variant="destructive" className="text-xs mt-1">Hidden</Badge>}
                              </div>
                              <div className="flex gap-1">
                                <Button size="sm" variant="ghost" onClick={() => {
                                  setSelectedPost(post);
                                  setEditPostDialogOpen(true);
                                }}>
                                  <Edit className="h-3 w-3" />
                                </Button>
                                <Button size="sm" variant="ghost" onClick={() => handleDeletePost(post.id)}>
                                  <Trash2 className="h-3 w-3 text-foreground" />
                                </Button>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="text-sm text-muted-foreground text-center py-8">No posts in this thread yet</p>
                      )
                    ) : (
                      <p className="text-sm text-muted-foreground text-center py-8">Select a thread from the left to view its posts</p>
                    )}
                  </CardContent>
                </Card>
              </div>
            </TabsContent>

            {/* Post Reports Tab */}
            <TabsContent value="reports" className="space-y-4">
              <Card>
                <CardHeader>
                  <CardTitle>Post Reports ({forumPostReports.length})</CardTitle>
                  <CardDescription>Review and manage reported forum posts</CardDescription>
                </CardHeader>
                <CardContent className="space-y-3">
                  {forumPostReports.length > 0 ? (
                    forumPostReports.map((report) => (
                      <Card key={report.id} className={report.status === 'pending' ? 'border-yellow-500' : ''}>
                        <CardContent className="p-4">
                          <div className="space-y-2">
                            <div className="flex items-start justify-between">
                              <div>
                                <Badge variant={
                                  report.status === 'pending' ? 'outline' :
                                  report.status === 'actioned' ? 'default' :
                                  'secondary'
                                }>
                                  {report.status}
                                </Badge>
                                <p className="text-xs text-muted-foreground mt-1">
                                  Reported by {report.reporter?.display_name || report.reporter?.full_name || report.reporter?.email}
                                </p>
                              </div>
                              <p className="text-xs text-muted-foreground">
                                {new Date(report.created_at).toLocaleDateString()}
                              </p>
                            </div>
                            
                            <div className="space-y-1">
                              <p className="text-sm font-semibold">Posted by:</p>
                              <p className="text-sm text-muted-foreground">
                                {report.forum_posts?.profiles?.display_name || report.forum_posts?.profiles?.full_name || report.forum_posts?.profiles?.email || 'Unknown user'}
                              </p>
                            </div>
                            
                            <div className="space-y-1">
                              <p className="text-sm font-semibold">Reason:</p>
                              <p className="text-sm text-muted-foreground">{report.reason}</p>
                            </div>
                            
                            <div className="space-y-1">
                              <p className="text-sm font-semibold">Post Content:</p>
                              <p className="text-sm text-muted-foreground line-clamp-3">{report.forum_posts?.content}</p>
                            </div>

                            <div className="flex gap-2 mt-3">
                              {report.status === 'pending' ? (
                                <>
                                  <Button 
                                    size="sm" 
                                    variant="destructive"
                                    onClick={() => handleHideReportedPost(report.post_id, report.id)}
                                  >
                                    Hide Post
                                  </Button>
                                  <Button 
                                    size="sm" 
                                    variant="outline"
                                    onClick={() => handleDismissReport(report.id)}
                                  >
                                    Dismiss
                                  </Button>
                                </>
                              ) : (
                                <Button 
                                  size="icon" 
                                  variant="ghost"
                                  onClick={() => handleDeleteReport(report.id)}
                                >
                                  <Trash2 className="h-4 w-4" />
                                </Button>
                              )}
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    ))
                  ) : (
                    <p className="text-sm text-muted-foreground text-center py-8">No reports to review</p>
                  )}
                </CardContent>
              </Card>
            </TabsContent>

            {/* Feature Requests Tab */}
            <TabsContent value="feature-requests" className="space-y-4">
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {featureRequests.map((request) => (
                  <Card key={request.id} className="cursor-pointer hover:shadow-lg transition-shadow">
                    <CardHeader onClick={() => {
                      setSelectedFeatureRequest(request);
                      setFeatureRequestDetailsOpen(true);
                    }}>
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <CardTitle className="text-base">{request.title}</CardTitle>
                          <CardDescription className="text-sm mt-1">
                            by {request.profiles?.display_name || request.profiles?.full_name || 'Unknown User'}
                          </CardDescription>
                        </div>
                        <div className="flex items-center gap-1 text-sm">
                          <ThumbsUp className="h-4 w-4" />
                          <span>{request.vote_count}</span>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent className="space-y-2">
                      <Badge variant={
                        request.status === 'added' ? 'default' :
                        request.status === 'planned' ? 'secondary' : 
                        request.status === 'rejected' ? 'destructive' :
                        'outline'
                      }>
                        {request.status || 'pending'}
                      </Badge>
                      <div className="grid grid-cols-2 gap-2">
                        <Button 
                          size="sm" 
                          variant="outline" 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleUpdateFeatureRequestStatus(request.id, 'planned');
                          }}
                          disabled={request.status === 'planned'}
                        >
                          Planned
                        </Button>
                        <Button 
                          size="sm" 
                          variant="outline" 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleUpdateFeatureRequestStatus(request.id, 'added');
                          }}
                          disabled={request.status === 'added'}
                        >
                          Added
                        </Button>
                        <Button 
                          size="sm" 
                          variant="outline" 
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedFeatureRequest(request);
                            setRejectDialogOpen(true);
                          }}
                          disabled={request.status === 'rejected'}
                        >
                          Reject
                        </Button>
                        <Button 
                          size="sm" 
                          variant="outline" 
                          onClick={async (e) => {
                            e.stopPropagation();
                            setSelectedThread(request);
                            // Fetch the first post for this thread
                            const { data: postData } = await supabase
                              .from('forum_posts')
                              .select('*')
                              .eq('thread_id', request.id)
                              .order('created_at', { ascending: true })
                              .limit(1)
                              .maybeSingle();
                            setSelectedThreadPost(postData);
                            setEditThreadDialogOpen(true);
                          }}
                        >
                          <Edit className="h-4 w-4" />
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>

              {/* Feature Request Details Dialog */}
              <Dialog open={featureRequestDetailsOpen} onOpenChange={setFeatureRequestDetailsOpen}>
                <DialogContent className="max-w-2xl">
                  <DialogHeader>
                    <DialogTitle>{selectedFeatureRequest?.title}</DialogTitle>
                    <DialogDescription>
                      Submitted by {selectedFeatureRequest?.profiles?.display_name || selectedFeatureRequest?.profiles?.full_name || 'Unknown User'}
                    </DialogDescription>
                  </DialogHeader>
                  {selectedFeatureRequest && (
                    <div className="space-y-4">
                      <div className="flex items-center gap-4">
                        <Badge variant={
                          selectedFeatureRequest.status === 'added' ? 'default' :
                          selectedFeatureRequest.status === 'planned' ? 'secondary' : 
                          selectedFeatureRequest.status === 'rejected' ? 'destructive' :
                          'outline'
                        }>
                          {selectedFeatureRequest.status || 'pending'}
                        </Badge>
                        <div className="flex items-center gap-1 text-sm">
                          <ThumbsUp className="h-4 w-4" />
                          <span>{selectedFeatureRequest.vote_count} votes</span>
                        </div>
                      </div>
                      
                      {selectedFeatureRequest.rejection_reason && (
                        <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-lg">
                          <p className="text-sm font-medium text-destructive mb-1">Rejection Reason:</p>
                          <p className="text-sm">{selectedFeatureRequest.rejection_reason}</p>
                        </div>
                      )}
                      
                      <div className="flex gap-2">
                        <Button 
                          variant="outline" 
                          onClick={() => handleUpdateFeatureRequestStatus(selectedFeatureRequest.id, 'planned')}
                          disabled={selectedFeatureRequest.status === 'planned'}
                        >
                          Mark as Planned
                        </Button>
                        <Button 
                          variant="outline" 
                          onClick={() => handleUpdateFeatureRequestStatus(selectedFeatureRequest.id, 'added')}
                          disabled={selectedFeatureRequest.status === 'added'}
                        >
                          Mark as Added
                        </Button>
                        <Button 
                          variant="outline" 
                          onClick={() => {
                            setFeatureRequestDetailsOpen(false);
                            setRejectDialogOpen(true);
                          }}
                          disabled={selectedFeatureRequest.status === 'rejected'}
                        >
                          Reject
                        </Button>
                        <Button 
                          variant="destructive" 
                          onClick={() => handleDeleteFeatureRequest(selectedFeatureRequest.id)}
                        >
                          <Trash2 className="h-4 w-4 mr-2" />
                          Delete
                        </Button>
                      </div>
                    </div>
                  )}
                </DialogContent>
              </Dialog>

              {/* Rejection Dialog */}
              <Dialog open={rejectDialogOpen} onOpenChange={setRejectDialogOpen}>
                <DialogContent>
                  <DialogHeader>
                    <DialogTitle>Reject Feature Request</DialogTitle>
                    <DialogDescription>
                      Optionally provide a reason for rejection (visible to users)
                    </DialogDescription>
                  </DialogHeader>
                  <div className="space-y-4">
                    <Textarea
                      placeholder="Reason for rejection (optional)..."
                      value={rejectionReason}
                      onChange={(e) => setRejectionReason(e.target.value)}
                      rows={4}
                    />
                    <div className="flex gap-2">
                      <Button
                        variant="outline"
                        onClick={() => {
                          setRejectDialogOpen(false);
                          setRejectionReason("");
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="destructive"
                        onClick={() => {
                          if (selectedFeatureRequest) {
                            handleUpdateFeatureRequestStatus(
                              selectedFeatureRequest.id, 
                              'rejected', 
                              rejectionReason
                            );
                          }
                        }}
                      >
                        Reject Request
                      </Button>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </TabsContent>
          </Tabs>
        </TabsContent>

        {/* Email Templates Tab */}
        <TabsContent value="emails" className="space-y-4">
          <EmailSetupInstructions />
          
          <Card>
            <CardHeader>
              <CardTitle>Email Templates</CardTitle>
              <CardDescription>Manage email templates for authentication and notifications</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                {emailTemplates.map((template) => (
                  <Card key={template.id} className="hover:shadow-lg transition-shadow">
                    <CardHeader>
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <CardTitle className="text-base flex items-center gap-2">
                            <Mail className="h-4 w-4" />
                            {template.template_name.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase())}
                          </CardTitle>
                          <CardDescription className="text-sm mt-2">{template.description}</CardDescription>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <div className="space-y-2">
                        <Badge variant={template.template_type === 'auth' ? 'default' : template.template_type === 'notification' ? 'secondary' : 'outline'}>
                          {template.template_type}
                        </Badge>
                        {template.is_system_template && (
                          <Badge variant="destructive" className="ml-2">System Template</Badge>
                        )}
                        <p className="text-sm text-muted-foreground mt-2"><strong>Subject:</strong> {template.subject.substring(0, 50)}...</p>
                        <div className="flex gap-2 mt-4">
                          <Button size="sm" variant="outline" onClick={() => {
                            setSelectedTemplate(template);
                            setEditTemplateDialogOpen(true);
                          }}>
                            <Edit className="h-4 w-4 mr-1" />Edit
                          </Button>
                          <Button size="sm" variant="outline" onClick={() => {
                            setSelectedTemplate(template);
                            setPreviewTemplateDialogOpen(true);
                          }}>
                            <Eye className="h-4 w-4 mr-1" />Preview
                          </Button>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* SEO Tab */}
        <TabsContent value="seo" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>SEO Metadata</CardTitle>
              <CardDescription>Manage SEO metadata for all pages</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {seoMetadata.map((seo) => (
                  <Card key={seo.id}>
                    <CardHeader>
                      <div className="flex items-start justify-between">
                        <div>
                          <CardTitle className="text-base">{seo.page_name}</CardTitle>
                          <CardDescription>/{seo.page_slug}</CardDescription>
                        </div>
                        <Button size="sm" variant="ghost" onClick={() => {
                          setSelectedSEO(seo);
                          setEditSEODialogOpen(true);
                        }}>
                          <Edit className="h-4 w-4" />
                        </Button>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <p className="text-sm"><strong>Title:</strong> {seo.title}</p>
                      <p className="text-sm text-muted-foreground mt-1">{seo.meta_description}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Payments Tab */}
        <TabsContent value="payments" className="space-y-4">
          <div className="grid gap-6 lg:grid-cols-2">
            <SiteMollieConnectionCard />
            
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <DollarSign className="h-5 w-5" />
                  Subscription Payments
                </CardTitle>
                <CardDescription>
                  How subscription payments are processed
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="p-4 bg-muted/50 rounded-lg">
                  <p className="text-sm font-medium mb-2">Payment Flow</p>
                  <ol className="space-y-2 text-sm text-muted-foreground list-decimal list-inside">
                    <li>PTA selects a plan (Basic £49.99/year or Standard £129.98/year)</li>
                    <li>Payment is processed through Mollie (if connected) or Stripe</li>
                    <li>Funds are deposited to your connected payment account</li>
                    <li>PTA subscription is automatically activated</li>
                  </ol>
                </div>
                
                <div className="p-4 bg-primary/5 border border-primary/20 rounded-lg">
                  <p className="text-sm font-medium mb-1">Current Payment Method</p>
                  <p className="text-sm text-muted-foreground">
                    Mollie is the preferred payment method for European PTAs. Connect your Mollie account to start receiving subscription payments.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </TabsContent>

        {/* Settings Tab */}
        <TabsContent value="settings" className="space-y-4">
          <Card>
            <CardHeader>
              <CardTitle>Registration Settings</CardTitle>
              <CardDescription>
                Control whether new users can create accounts
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="flex items-center justify-between">
                <div>
                  <Label htmlFor="registrations-toggle" className="text-base">Disable New Registrations</Label>
                  <p className="text-sm text-muted-foreground mt-1">
                    When enabled, new users cannot create accounts. Existing users can still log in.
                  </p>
                </div>
                <Switch
                  id="registrations-toggle"
                  checked={registrationsDisabled}
                  onCheckedChange={(checked) => setRegistrationsDisabled(checked as boolean)}
                />
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Maintenance Mode</CardTitle>
              <CardDescription>
                Control site availability and maintenance messaging
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="flex items-center justify-between">
                <div>
                  <Label htmlFor="maintenance-toggle" className="text-base">Enable Maintenance Mode</Label>
                  <p className="text-sm text-muted-foreground mt-1">
                    When enabled, only site administrators can access the site by logging in
                  </p>
                </div>
                <Switch
                  id="maintenance-toggle"
                  checked={maintenanceEnabled}
                  onCheckedChange={(checked) => setMaintenanceEnabled(checked as boolean)}
                />
              </div>
              
              <div>
                <Label>Maintenance Message</Label>
                <Textarea
                  value={maintenanceMessage}
                  onChange={(e) => setMaintenanceMessage(e.target.value)}
                  rows={4}
                  placeholder="Enter the message users will see during maintenance..."
                  className="mt-2"
                />
              </div>
            </CardContent>
          </Card>

          <Button onClick={handleUpdateMaintenance} className="w-full">
            Save All Settings
          </Button>
      </TabsContent>

      {/* PTAs Tab Content */}
      <TabsContent value="ptas" className="space-y-6">
        <Card>
          <CardHeader>
            <div className="flex items-center justify-between">
              <div>
                <CardTitle>PTAs</CardTitle>
                <CardDescription>Manage all PTAs on the platform</CardDescription>
              </div>
              <Button onClick={openAddPTA} size="sm">
                <Plus className="h-4 w-4 mr-2" />
                Add PTA
              </Button>
            </div>
            <div className="relative mt-4">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Search by name, school, or county..."
                value={searchPTAs}
                onChange={(e) => setSearchPTAs(e.target.value)}
                className="pl-10"
              />
            </div>
          </CardHeader>
          <CardContent>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Name</TableHead>
                  <TableHead>School</TableHead>
                  <TableHead>County</TableHead>
                  <TableHead>Charity No.</TableHead>
                  <TableHead>Email</TableHead>
                  <TableHead>Created</TableHead>
                  <TableHead>Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {allPTAs.filter(p => {
                  const q = searchPTAs.toLowerCase();
                  return (p.name || "").toLowerCase().includes(q) ||
                         (p.school_name || "").toLowerCase().includes(q) ||
                         (p.county || "").toLowerCase().includes(q);
                }).map((pta: any) => (
                  <TableRow key={pta.id}>
                    <TableCell className="font-medium">{pta.name}</TableCell>
                    <TableCell>{pta.school_name || "-"}</TableCell>
                    <TableCell>{pta.county || "-"}</TableCell>
                    <TableCell>{pta.charity_number || "-"}</TableCell>
                    <TableCell>{pta.shared_email || "-"}</TableCell>
                    <TableCell>{pta.created_at ? new Date(pta.created_at).toLocaleDateString() : "-"}</TableCell>
                    <TableCell>
                      <div className="flex items-center gap-2">
                        <button onClick={() => openEditPTA(pta)} title="Edit">
                          <Edit className="h-4 w-4 text-black hover:opacity-70" />
                        </button>
                        <button onClick={() => handleDeletePTA(pta.id, pta.name)} title="Delete">
                          <Trash2 className="h-4 w-4 text-black hover:opacity-70" />
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </TabsContent>

      </Tabs>
      )}

      <EditUserDialog
        open={editUserDialogOpen}
        onOpenChange={setEditUserDialogOpen}
        user={selectedUser}
        onSuccess={fetchUsers}
      />

      <EditSubscriptionDialog
        open={editSubDialogOpen}
        onOpenChange={setEditSubDialogOpen}
        subscription={selectedSub}
        onSuccess={fetchSubscriptions}
      />

      {selectedShopItem && (
        <EditShopItemDialog
          item={selectedShopItem}
          open={editShopDialogOpen}
          onOpenChange={setEditShopDialogOpen}
          onSuccess={fetchShopItems}
          categories={[]}
        />
      )}

      {selectedPlan && (
        <EditPricingPlanDialog
          plan={selectedPlan}
          features={selectedPlanFeatures}
          open={editPlanDialogOpen}
          onOpenChange={setEditPlanDialogOpen}
          onSuccess={fetchPricingPlans}
        />
      )}

      <EditAddonDialog
        addon={selectedAddon}
        open={editAddonDialogOpen}
        onOpenChange={setEditAddonDialogOpen}
        onSuccess={fetchAddons}
      />

      {selectedPolicy && (
        <EditPolicyDialog
          policy={selectedPolicy}
          open={editPolicyDialogOpen}
          onOpenChange={setEditPolicyDialogOpen}
          onSuccess={fetchPolicies}
        />
      )}

      <EditEmailTemplateDialog
        template={selectedTemplate}
        open={editTemplateDialogOpen}
        onOpenChange={setEditTemplateDialogOpen}
        onSuccess={fetchEmailTemplates}
      />

      <PreviewEmailTemplateDialog
        template={selectedTemplate}
        open={previewTemplateDialogOpen}
        onOpenChange={setPreviewTemplateDialogOpen}
      />

      <EditSEODialog
        seoData={selectedSEO}
        open={editSEODialogOpen}
        onOpenChange={setEditSEODialogOpen}
        onSuccess={fetchSEOMetadata}
      />

      {/* Edit Category Dialog */}
      <Dialog open={editCategoryDialogOpen} onOpenChange={setEditCategoryDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit Category</DialogTitle>
          </DialogHeader>
          {selectedCategory && (
            <div className="space-y-4">
              <div>
                <Label>Name</Label>
                <Input 
                  value={selectedCategory.name} 
                  onChange={(e) => setSelectedCategory({ ...selectedCategory, name: e.target.value })} 
                />
              </div>
              <div>
                <Label>Description</Label>
                <Textarea 
                  value={selectedCategory.description || ''} 
                  onChange={(e) => setSelectedCategory({ ...selectedCategory, description: e.target.value })} 
                  rows={2}
                />
              </div>
              <Button onClick={handleUpdateCategory} className="w-full">Update Category</Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Edit Thread Dialog */}
      <Dialog open={editThreadDialogOpen} onOpenChange={setEditThreadDialogOpen}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Edit Feature Request</DialogTitle>
          </DialogHeader>
          {selectedThread && (
            <div className="space-y-4">
              <div>
                <Label>Title</Label>
                <Input 
                  value={selectedThread.title} 
                  onChange={(e) => setSelectedThread({ ...selectedThread, title: e.target.value })} 
                />
              </div>
              
              {selectedThreadPost && (
                <div>
                  <Label>Description</Label>
                  <Textarea 
                    value={selectedThreadPost.content} 
                    readOnly
                    rows={8}
                    className="bg-muted"
                  />
                </div>
              )}
              
              <div className="flex items-center space-x-2">
                <Checkbox
                  id="pinned"
                  checked={selectedThread.is_pinned}
                  onCheckedChange={(checked) => setSelectedThread({ ...selectedThread, is_pinned: checked })}
                />
                <label htmlFor="pinned" className="text-sm cursor-pointer">Pinned</label>
              </div>
              <div className="flex items-center space-x-2">
                <Checkbox
                  id="locked"
                  checked={selectedThread.is_locked}
                  onCheckedChange={(checked) => setSelectedThread({ ...selectedThread, is_locked: checked })}
                />
                <label htmlFor="locked" className="text-sm cursor-pointer">Locked</label>
              </div>
              
              <div className="flex items-center gap-2">
                <Badge variant={
                  selectedThread.status === 'added' ? 'default' :
                  selectedThread.status === 'planned' ? 'secondary' : 
                  selectedThread.status === 'rejected' ? 'destructive' :
                  'outline'
                }>
                  {selectedThread.status || 'pending'}
                </Badge>
                <span className="text-sm text-muted-foreground">
                  {selectedThread.vote_count} votes
                </span>
              </div>
              
              <Button onClick={handleUpdateThread} className="w-full">Update Thread</Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Edit Post Dialog */}
      <Dialog open={editPostDialogOpen} onOpenChange={setEditPostDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit Post</DialogTitle>
          </DialogHeader>
          {selectedPost && (
            <div className="space-y-4">
              <div>
                <Label>Title</Label>
                <Input 
                  value={selectedPost.title} 
                  onChange={(e) => setSelectedPost({ ...selectedPost, title: e.target.value })} 
                />
              </div>
              <div>
                <Label>Content</Label>
                <Textarea 
                  value={selectedPost.content} 
                  onChange={(e) => setSelectedPost({ ...selectedPost, content: e.target.value })} 
                  rows={6}
                />
              </div>
              <div className="flex items-center space-x-2">
                <Checkbox
                  id="hidden"
                  checked={selectedPost.is_hidden}
                  onCheckedChange={(checked) => setSelectedPost({ ...selectedPost, is_hidden: checked })}
                />
                <label htmlFor="hidden" className="text-sm cursor-pointer">Hide Post</label>
              </div>
              <Button onClick={handleUpdatePost} className="w-full">Update Post</Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Edit Blog Post Dialog */}
      <Dialog open={editBlogDialogOpen} onOpenChange={setEditBlogDialogOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Edit Blog Post</DialogTitle>
          </DialogHeader>
          {selectedBlogPost && (
            <form onSubmit={handleUpdateBlogPost} className="space-y-4">
              <div>
                <Label>Title</Label>
                <Input 
                  value={selectedBlogPost.title}
                  onChange={(e) => setSelectedBlogPost({ ...selectedBlogPost, title: e.target.value })}
                  required
                />
              </div>
              <div>
                <Label>Author Name</Label>
                <Input 
                  value={selectedBlogPost.author_name || ''}
                  onChange={(e) => setSelectedBlogPost({ ...selectedBlogPost, author_name: e.target.value })}
                  placeholder="e.g., John Smith"
                />
              </div>
              <div>
                <Label>Tags (comma separated)</Label>
                <Input 
                  value={(selectedBlogPost.tags || []).join(', ')}
                  onChange={(e) => setSelectedBlogPost({ 
                    ...selectedBlogPost, 
                    tags: e.target.value.split(',').map((t: string) => t.trim()).filter((t: string) => t)
                  })}
                  placeholder="e.g., Tips, Fundraising, Events"
                />
              </div>
              <div>
                <Label>Excerpt</Label>
                <Textarea 
                  value={selectedBlogPost.excerpt || ''}
                  onChange={(e) => setSelectedBlogPost({ ...selectedBlogPost, excerpt: e.target.value })}
                  rows={2}
                />
              </div>
              <div>
                <Label>Content</Label>
                <Textarea 
                  value={selectedBlogPost.content}
                  onChange={(e) => setSelectedBlogPost({ ...selectedBlogPost, content: e.target.value })}
                  rows={10}
                  required
                />
              </div>
              <div>
                <Label>Image</Label>
                {selectedBlogPost.image_url && !editBlogImageFile && (
                  <div className="mb-2">
                    <img src={selectedBlogPost.image_url} alt="Current" className="h-32 w-auto rounded" />
                  </div>
                )}
                <Input 
                  type="file" 
                  accept="image/*"
                  onChange={(e) => setEditBlogImageFile(e.target.files?.[0] || null)}
                />
              </div>
              <Button type="submit" className="w-full">Update Blog Post</Button>
            </form>
          )}
        </DialogContent>
      </Dialog>

      {/* Edit Fundraising Idea Dialog */}
      <Dialog open={editIdeaDialogOpen} onOpenChange={setEditIdeaDialogOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Edit Fundraising Idea</DialogTitle>
            <DialogDescription>Update the fundraising idea details and image</DialogDescription>
          </DialogHeader>
          {selectedIdea && (
            <div className="space-y-4">
              <div>
                <Label htmlFor="edit-title">Title *</Label>
                <Input 
                  id="edit-title" 
                  value={selectedIdea.title} 
                  onChange={(e) => setSelectedIdea({ ...selectedIdea, title: e.target.value })} 
                  placeholder="e.g., Summer Fair"
                />
              </div>
              <div>
                <Label htmlFor="edit-description">Short Description *</Label>
                <Textarea 
                  id="edit-description" 
                  value={selectedIdea.description} 
                  onChange={(e) => setSelectedIdea({ ...selectedIdea, description: e.target.value })} 
                  placeholder="Brief overview of the fundraising idea"
                  rows={3} 
                />
              </div>
              <div>
                <Label htmlFor="edit-detailed-plan">Detailed Plan *</Label>
                <Textarea 
                  id="edit-detailed-plan" 
                  value={selectedIdea.detailed_plan} 
                  onChange={(e) => setSelectedIdea({ ...selectedIdea, detailed_plan: e.target.value })} 
                  placeholder="Step-by-step guide on how to execute this idea"
                  rows={6} 
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Type (select all that apply)</Label>
                  <div className="space-y-2 mt-2">
                    {['Event', 'Stall'].map((type) => (
                      <div key={type} className="flex items-center space-x-2">
                        <Checkbox
                          id={`edit-type-${type}`}
                          checked={selectedIdea.type?.includes(type) || false}
                          onCheckedChange={(checked) => {
                            const newType = checked
                              ? [...(selectedIdea.type || []), type]
                              : (selectedIdea.type || []).filter((t: string) => t !== type);
                            setSelectedIdea({ ...selectedIdea, type: newType });
                          }}
                        />
                        <label htmlFor={`edit-type-${type}`} className="text-sm cursor-pointer">{type}</label>
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  <Label>Season (select all that apply)</Label>
                  <div className="space-y-2 mt-2">
                    {['Spring', 'Summer', 'Autumn', 'Winter', 'All Year'].map((season) => (
                      <div key={season} className="flex items-center space-x-2">
                        <Checkbox
                          id={`edit-season-${season}`}
                          checked={selectedIdea.season?.includes(season) || false}
                          onCheckedChange={(checked) => {
                            const newSeason = checked
                              ? [...(selectedIdea.season || []), season]
                              : (selectedIdea.season || []).filter((s: string) => s !== season);
                            setSelectedIdea({ ...selectedIdea, season: newSeason });
                          }}
                        />
                        <label htmlFor={`edit-season-${season}`} className="text-sm cursor-pointer">{season}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div>
                <Label>Location (select all that apply)</Label>
                <div className="grid grid-cols-3 gap-4 mt-2">
                  {['Indoor', 'Outdoor', 'Online'].map((location) => (
                    <div key={location} className="flex items-center space-x-2">
                      <Checkbox
                        id={`edit-location-${location}`}
                        checked={selectedIdea.location?.includes(location) || false}
                        onCheckedChange={(checked) => {
                          const newLocation = checked
                            ? [...(selectedIdea.location || []), location]
                            : (selectedIdea.location || []).filter((l: string) => l !== location);
                          setSelectedIdea({ ...selectedIdea, location: newLocation });
                        }}
                      />
                      <label htmlFor={`edit-location-${location}`} className="text-sm cursor-pointer">{location}</label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <Label htmlFor="edit-helpers">Estimated Helpers</Label>
                  <Input
                    id="edit-helpers"
                    type="number"
                    value={selectedIdea.estimated_helpers || 0}
                    onChange={(e) => setSelectedIdea({ ...selectedIdea, estimated_helpers: parseInt(e.target.value) || 0 })}
                    placeholder="e.g., 5"
                  />
                </div>
                <div>
                  <Label htmlFor="edit-income">Estimated Income</Label>
                  <Input
                    id="edit-income"
                    value={selectedIdea.estimated_income || '£0'}
                    onChange={(e) => setSelectedIdea({ ...selectedIdea, estimated_income: e.target.value })}
                    placeholder="£0"
                  />
                </div>
                <div>
                  <Label htmlFor="edit-pricing">Estimated Pricing</Label>
                  <Input
                    id="edit-pricing"
                    value={selectedIdea.estimated_pricing || '£0'}
                    onChange={(e) => setSelectedIdea({ ...selectedIdea, estimated_pricing: e.target.value })}
                    placeholder="£0"
                  />
                </div>
              </div>
              {/* User-submitted images - admin can remove inappropriate ones */}
              <div>
                <Label>User-Submitted Images</Label>
                <p className="text-xs text-muted-foreground mb-2">
                  These images will appear on the detail page. Remove any inappropriate images by clicking the X button.
                </p>
                {selectedIdea.images && selectedIdea.images.length > 0 ? (
                  <div className="grid grid-cols-3 gap-2 mt-2">
                    {selectedIdea.images.map((img: string, index: number) => (
                      <div key={index} className="relative group aspect-square overflow-hidden rounded-lg border">
                        <img 
                          src={img}
                          alt={`User image ${index + 1}`}
                          className="w-full h-full object-cover"
                        />
                        <Button
                          type="button"
                          variant="destructive"
                          size="icon"
                          className="absolute top-1 right-1 h-6 w-6 opacity-0 group-hover:opacity-100 transition-opacity"
                          onClick={() => {
                            const updatedImages = selectedIdea.images.filter(
                              (_: string, idx: number) => idx !== index
                            );
                            setSelectedIdea({ ...selectedIdea, images: updatedImages });
                          }}
                        >
                          <X className="h-3 w-3" />
                        </Button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="space-y-3">
                    <p className="text-sm text-muted-foreground p-3 bg-muted border border-border rounded-lg">
                      No images were submitted by the user. Use the uploader below to add images for the detail page.
                    </p>
                    <ImageUploader
                      id="detail-images-upload"
                      images={selectedIdea.images || []}
                      onChange={(urls) => {
                        setSelectedIdea({ ...selectedIdea, images: urls });
                      }}
                      maxImages={3}
                      ptaId="site-admin"
                      itemId={selectedIdea?.id || 'new'}
                      bucket="fundraising-images"
                    />
                  </div>
                )}
              </div>
              
              {/* Cover Image - Admin Controlled */}
              <div>
                <Label>Cover Image (Admin Controlled)</Label>
                <p className="text-xs text-muted-foreground mb-2">This image appears as the thumbnail on the library cards</p>
                <ImageUploader
                  id="cover-image-upload"
                  images={selectedIdea.image_url ? [selectedIdea.image_url] : []}
                  onChange={(urls) => {
                    setSelectedIdea({
                      ...selectedIdea,
                      image_url: urls[0] || null
                    });
                  }}
                  maxImages={1}
                  ptaId="site-admin"
                  itemId={selectedIdea?.id || 'new'}
                  bucket="fundraising-images"
                />
              </div>

              <Button onClick={handleUpdateIdea} disabled={loading} className="w-full">
                {loading ? "Updating..." : "Update Idea"}
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Idea Rejection Dialog */}
      <Dialog open={ideaRejectDialogOpen} onOpenChange={setIdeaRejectDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Reject Idea</DialogTitle>
            <DialogDescription>
              Please provide a reason for rejecting this idea. The submitter will be notified via email.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            {ideaToReject && (
              <div className="p-3 bg-muted rounded-lg">
                <p className="font-medium">{ideaToReject.title}</p>
              </div>
            )}
            <div>
              <Label htmlFor="rejection-reason">Rejection Reason</Label>
              <Textarea
                id="rejection-reason"
                placeholder="Enter the reason for rejection..."
                value={ideaRejectionReason}
                onChange={(e) => setIdeaRejectionReason(e.target.value)}
                rows={4}
              />
            </div>
            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={() => setIdeaRejectDialogOpen(false)}>
                Cancel
              </Button>
              <Button 
                variant="destructive" 
                onClick={handleRejectIdea}
                disabled={isRejectingIdea || !ideaRejectionReason.trim()}
              >
                {isRejectingIdea ? (
                  <>
                    <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    Rejecting...
                  </>
                ) : (
                  <>
                    <X className="h-4 w-4 mr-2" />
                    Reject & Notify
                  </>
                )}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>


      {/* Add/Edit PTA Dialog */}
      <Dialog open={editPTADialogOpen} onOpenChange={(open) => {
        setEditPTADialogOpen(open);
        if (!open) setSelectedPTA(null);
      }}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{selectedPTA ? "Edit PTA" : "Add PTA"}</DialogTitle>
            <DialogDescription>
              {selectedPTA ? "Update PTA details." : "Create a new PTA."}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Name *</Label>
              <Input value={ptaForm.name} onChange={(e) => setPtaForm(prev => ({ ...prev, name: e.target.value }))} />
            </div>
            <div>
              <Label>School Name</Label>
              <Input value={ptaForm.school_name} onChange={(e) => setPtaForm(prev => ({ ...prev, school_name: e.target.value }))} />
            </div>
            <div>
              <Label>County</Label>
              <Input value={ptaForm.county} onChange={(e) => setPtaForm(prev => ({ ...prev, county: e.target.value }))} />
            </div>
            <div>
              <Label>Charity Number</Label>
              <Input value={ptaForm.charity_number} onChange={(e) => setPtaForm(prev => ({ ...prev, charity_number: e.target.value }))} />
            </div>
            <div>
              <Label>Shared Email</Label>
              <Input type="email" value={ptaForm.shared_email} onChange={(e) => setPtaForm(prev => ({ ...prev, shared_email: e.target.value }))} />
            </div>
            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={() => setEditPTADialogOpen(false)}>Cancel</Button>
              <Button onClick={handleSavePTA}>Save</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Edit Parent Dialog */}
      <Dialog open={editParentDialogOpen} onOpenChange={(open) => {
        setEditParentDialogOpen(open);
        if (!open) {
          setSelectedParent(null);
        }
      }}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit Parent</DialogTitle>
            <DialogDescription>
              Update parent account details.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label htmlFor="parent-name">Full Name</Label>
              <Input
                id="parent-name"
                value={editParentForm.full_name}
                onChange={(e) => setEditParentForm(prev => ({ ...prev, full_name: e.target.value }))}
              />
            </div>
            <div>
              <Label htmlFor="parent-email">Email</Label>
              <Input
                id="parent-email"
                type="email"
                value={editParentForm.email}
                onChange={(e) => setEditParentForm(prev => ({ ...prev, email: e.target.value }))}
              />
            </div>
            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={() => setEditParentDialogOpen(false)}>
                Cancel
              </Button>
              <Button onClick={handleUpdateParent}>
                Save Changes
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

